/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { evaluate, nullDependencies } from "mathjs";
import { useSelector, useDispatch } from "react-redux";
import { toNumber, getItemFromArray, Cos, Sin, Tan, BaseURL, shadeColor } from "../../components/Common";

import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import Draggable from "react-draggable";
import Slider from "@material-ui/core/Slider";
import MenuItem from "@material-ui/core/MenuItem";
import * as BSL_Common from "../../components/BSL_CommonControls";
import * as APP from "../../redux_store/appState";
import * as CONFIG from "../../redux_store/configState";
import { DESIGN_TYPES } from "../../redux_store/configState";
import paper from "paper";
import WarningIcon from "@material-ui/icons/Warning";

import { blue } from "@material-ui/core/colors";

import {
    updateAreaSpecificationModificationArray,
    deleteFromAreaSpecificationModificationArray,
    updateAreaSpecificationShape,
    updateSiteParameters,
    updateAreaSpecificationJob,
} from "../../redux_store/jobState";
import { SITE_PARAMETER_SECTIONS, BASIC_SPECS_SECTIONS } from "../../redux_store/jobState_Schemas";
import BSL_Select from "../../components/BSL_Select";
import BSL_Slider from "../../components/BSL_Slider";
import BSL_CheckBox from "../../components/BSL_CheckBox";
import SegmentedButtonGroup from "../../components/SegmentedButtonGroup";
import BSL_ControlContainer from "../../components/BSL_ControlContainer";
import BSL_TextInput from "../../components/BSL_TextInput";
import { GetBeamHeight } from "../../components_designer/main_drawer/BracketDesignerHelper";
import { getOffsets, adjustOffsetForSide } from "./SpecModifyAttachmentHelper";

const AttachmentSlider = withStyles({
    root: {
        color: "#3a8589",
        height: 3,
        padding: "13px 0",
        marginTop: "-8px",
    },
    thumb: {
        height: 24,
        width: 24,
        backgroundColor: "#fff",
        border: "2px solid currentColor",
        marginTop: -8,
        marginLeft: -12,
        "&:focus, &:hover, &$active": {
            boxShadow: "inherit",
        },
    },
    active: {},
    valueLabel: {
        left: "calc(-50% + 3px)",
        top: 30,
        "& *": {
            background: "transparent",
            color: "#000",
        },
    },
    track: {
        height: 30,
        marginTop: -23,
        background: "repeating-linear-gradient(45deg,#B1B118,#B1B118 2px,#F0F2E6 2px,#F0F2E6 10px)",
    },
    rail: {
        color: "#FFF",
        opacity: 1,
        height: 5,
        border: "1px solid #7AB004",
    },
})(Slider);

var _this = {};

function PaperComponent(props) {
    const is_deck_mode = useSelector((state) => state.job?.DesignParameters?.DeckMode);
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper
                id="draggable-dialog-title"
                {...props}
                style={{
                    maxWidth: "none",
                    width: is_deck_mode ? "600px" : "1300px",
                    minWidth: "480px",
                }}
            />
        </Draggable>
    );
}

const useStyles = makeStyles({
    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
    root: {
        width: 300,
    },
    handleText: {
        textAlign: "center",
        background: "#ffffffbd",
        width: "60px",
        border: "1px",
        position: "absolute",
        top: "-35px",
        display: "inline",
    },
    attachLengthText: {
        textAlign: "center",
        width: "55px",
        border: "0px",
        display: "inline",
    },
    label: {
        whiteSpace: "nowrap",
    },
});

function valuetext(value) {
    return `{value}mm`;
}

// var attachment_types = null
// export const ATTACHMENT_TYPES = (attachment_data_to_merge = null) => {
//     if (attachment_types === null) {
//         attachment_types = {...attachment_types};
//     }
//     if (attachment_data_to_merge) {
//         attachment_types = {...ATTACHMENT_TYPES_template, ...attachment_data_to_merge};
//     }
//     return attachment_types;
// }

function translate_roof_alignment(sheet_direction, roof_alignment_default) {
    if (sheet_direction == "Left") {
        if (roof_alignment_default === "Back") roof_alignment_default = "Side";
        else if (roof_alignment_default === "Side") roof_alignment_default = "Front";
        else if (roof_alignment_default === "Front") roof_alignment_default = "RightSide";
        else if (roof_alignment_default === "RightSide") roof_alignment_default = "Back";
    }
    if (sheet_direction == "Right") {
        if (roof_alignment_default === "Back") roof_alignment_default = "RightSide";
        else if (roof_alignment_default === "RightSide") roof_alignment_default = "Front";
        else if (roof_alignment_default === "Front") roof_alignment_default = "Side";
        else if (roof_alignment_default === "Side") roof_alignment_default = "Back";
    }
    return roof_alignment_default;
}
function translate_roof_alignment_pitched(roof_alignment_default) {
    return roof_alignment_default.includes("Side") ? "Back" : "Side";
}

function getCutoutSide(ref) {
    let cutout_side = "BackRight";
    if (ref.startsWith("CBR")) cutout_side = "BackRight";
    if (ref.startsWith("CBM")) cutout_side = "BackMid";
    if (ref.startsWith("CBL")) cutout_side = "BackLeft";
    if (ref.startsWith("CFL")) cutout_side = "FontLeft";
    if (ref.startsWith("CFR")) cutout_side = "FontRight";
    return cutout_side;
}
export default function SpecModifyAttachmentDialog2(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { onCancel, onSave, selectedValue, open, item } = props;

    const [devMode, setDevMode] = React.useState(props?.devmode);

    const logged_user_code = useSelector((state) => state.app.logged_user_code);
    const SiteParameters = useSelector((state) => state.job?.SiteParameters);

    const config = useSelector((state) => state.config);
    const ConfigDesignOptions = useSelector((state) => state.config.design_options);

    const JobExistingStructure = SiteParameters?.ExistingStructure;
    const AreaSpecifications = useSelector((state) => state.job?.AreaSpecifications);
    const is_deck_mode = useSelector((state) => state.job?.DesignParameters?.DeckMode);
    const areaData = AreaSpecifications?.[item.areaIndex];

    const ATTACHMENT_TYPES = useSelector((state) => state.config.attachment_types);

    const designType = AreaSpecifications?.[item.areaIndex]?.SHAPE?.DesignType;
    const design_options = ConfigDesignOptions?.[designType];

    //
    const attach_tag = item?.attach_tag;
    const areaDataAttachments = areaData?.ATTACHMENTS;
    const areaDataPartialAttachments = areaDataAttachments?.PARTIAL_ATTACHMENTS;
    const areaDataAttachmentModifications = areaDataAttachments?.AttachmentModifications;
    const roof_sheet_data = areaData?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData;
    const roof_sheet_height = roof_sheet_data?.sheet_height ? roof_sheet_data?.sheet_height : 100;
    const bracket_width = 50;

    let ref = item ? (item?.ref2 ? item?.ref2 : item?.ref) : null;
    let data_mods = getItemFromArray(areaDataAttachmentModifications, "Ref", ref);

    let roof_alignment_default = "Back";

    if (areaData?.SHAPE?.DesignType === DESIGN_TYPES.FLAT) {
        roof_alignment_default = translate_roof_alignment(areaData?.SHAPE?.SheetDirection, roof_alignment_default);
    }

    //defaults
    const default_EaveDepth = JobExistingStructure ? JobExistingStructure.EaveDepth : 600;
    const default_WallHeight = JobExistingStructure ? JobExistingStructure.WallHeight : 4000;
    const default_FasciaType = JobExistingStructure ? JobExistingStructure.AttachmentType : "Timber Fascia Drop";

    const [eaveValue, setEaveValue] = React.useState(data_mods ? data_mods.EaveWidth : default_EaveDepth);
    const [hOffset, setHOffset] = React.useState(data_mods?.hOffset ? data_mods.hOffset : 0);
    const [vDisplayOffset, setVDisplayOffset] = React.useState(0);
    const [vOffset, setVOffset] = React.useState(data_mods?.vOffset ? data_mods.vOffset : 0);
    const [riserHeight, setRiserHeight] = React.useState(0);
    const [hasBC, setHasBC] = React.useState(true);
    // const [hasBeam, setHasBeam] = React.useState(false);
    const [wallType, setWallType] = React.useState("Brick Veneer");
    const [house_pitch, setHousePitch] = React.useState(22.5);
    const [area_height, setAreaHeight] = React.useState(areaData?.SHAPE?.Height ? areaData?.SHAPE?.Height : 3400);

    const [state_attachment_length, setAttachmentLength] = React.useState(null);

    const [state_paatValues, setPaatValues] = React.useState(null);
    const [state_paatGutterValue, setPaatGutterValue] = React.useState(null);
    const [state_numBrackets, setnumBrackets] = React.useState(null);
    const [state_rSBLC, setRSBLC] = React.useState(null);
    const [state_extendAttachmentToSheetEnd, setExtendAttachmentToSheetEnd] = React.useState(null);
    const [state_partialAttachmentFasciaBeamFlush, setPartialAttachmentFasciaBeamFlush] = React.useState(null);
    const [state_fasciaIsRaked, setFasciaIsRaked] = React.useState(null);
    const [state_leftCantilever, setLeftCantilever] = React.useState(null);
    const [state_rightCantilever, setRightCantilever] = React.useState(null);
    const [initialised, setInitialise] = React.useState(false);
    const [attachDisplay, setAttachDisplay] = React.useState(null);

    const [wallHeightValue, setWallHeight] = React.useState(data_mods ? data_mods.WallHeight : default_WallHeight);
    const [attachmentLabel, setAttachmentLabel] = React.useState(data_mods ? data_mods.AttachmentLabel : "");

    const [_roofAlignment, setRoofAlignment] = React.useState("");
    let roofAlignment = _roofAlignment;
    const [_roof_pitch, setRoof_pitch] = React.useState(0);
    let roof_pitch = _roof_pitch;
    const [_attachmentTypeValue, setAttachmentType] = React.useState("");
    let attachmentTypeValue = _attachmentTypeValue;

    const [_attachmentTypeVariation, setAttachmentTypeVariation] = React.useState("");
    let attachmentTypeVariation = _attachmentTypeVariation;

    const [brand, setBrand] = React.useState(window.LYSAGHT ? "Lysaght" : "Fielders");

    React.useEffect(() => {
        if (initialised) {
            DrawAttachment();
            zoomAll();
        } else if (!initialised) {
            if (window.attach_paper_initialising) {
            } else {
                // let done = InitialiseCanvas("attachmentCanvas");
                //
                // if (done) {
                //     DrawAttachment();
                //     zoomAll();
                //     setInitialise(true);
                //     window.attach_paper_initialising = false;
                // } else {
                //     window.attach_paper_initialising = false;
                // }
            }
        }
    }, [
        eaveValue,
        hOffset,
        vOffset,
        hasBC,
        attachmentTypeValue,
        wallType,
        roof_pitch,
        attachmentTypeVariation,
        area_height,
        house_pitch,
        riserHeight,
        roofAlignment,
        brand,
        state_attachment_length,
        state_paatValues,
        state_paatGutterValue,
        initialised,
        state_numBrackets,
    ]);

    React.useEffect(() => {
        if (attachmentTypeValue) {
            let value = attachmentTypeValue;
            attachmentDefinitionRaw = ATTACHMENT_TYPES?.[value];

            if (ATTACHMENT_TYPES?.[value]?.has_backchannel !== undefined)
                setHasBC(ATTACHMENT_TYPES?.[value]?.has_backchannel);

            let this_attachmentTypeVariation = attachmentTypeVariation;
            if (ATTACHMENT_TYPES?.[value]?.variations?.[attachmentTypeVariation]) {
            } else {
                if (ATTACHMENT_TYPES?.[value]?.variations) {
                    this_attachmentTypeVariation = Object.keys(ATTACHMENT_TYPES?.[value]?.variations)?.[0];
                    setAttachmentTypeVariation(this_attachmentTypeVariation);
                } else {
                    this_attachmentTypeVariation = "";
                    setAttachmentTypeVariation(this_attachmentTypeVariation);
                }
            }

            let offsets = getOffsets(
                attachmentDefinition,
                beam_height,
                roof_sheet_height,
                eaveValue,
                roofAlignment,
                !initialised ? (data_mods ? vOffset : null) : null,
                !initialised ? (data_mods ? hOffset : null) : null
            );
            offsets = adjustOffsetForSide(ref, offsets, roofAlignment, areaData);

            let new_h_offset = offsets.h;
            let new_v_offset = offsets.v;
            if (new_h_offset !== hOffset) {
                setHOffset(new_h_offset);
            }
            if (new_v_offset !== vOffset) {
                setVOffset(new_v_offset);
            }
            if (offsets.v_display !== undefined) {
                setVDisplayOffset(offsets.v_display);
            } else {
                setVDisplayOffset(0);
            }
            // if (offsets.h_display !== undefined) {
            //     setHDisplayOffset(offsets.h_display);
            // } else {
            //     setHDisplayOffset(0);
            // }
            // if (!attachment_types?.[value]?.depth_offset_editable) {
            //     //change defaults is initialised, otherwise don't!
            //     if (value.includes("Flyover")) {
            //         setHOffset(-(eaveValue + 110 + 50 + 90));
            //     } else if (attachment_types?.[value]?.depth_offset_default !== undefined) {
            //         if (attachment_types?.[value]?.depth_offset_default === "150-Beam_Width") {
            //             if (window.LYSAGHT) setHOffset(150 - 50);
            //             else setHOffset(150 - 65);
            //         } else setHOffset(attachment_types?.[value]?.depth_offset_default);
            //     }
            // }

            // if (!attachment_types?.[value]?.height_offset_editable) {
            //     if (attachment_types?.[value]?.height_offset_default !== undefined) {
            //         if (attachment_types?.[value]?.height_offset_default === "Beam_Height") setVOffset(beam_height);
            //         else if (attachment_types?.[value]?.height_offset_default === "Beam_Height-50")
            //             setVOffset(beam_height - 50);
            //         else if (attachment_types?.[value]?.height_offset_default === "-Sheet_Height")
            //             setVOffset(-roof_sheet_height);
            //         else setVOffset(attachment_types?.[value]?.height_offset_default);
            //     }
            // }
        }
    }, [attachmentTypeValue]);

    React.useEffect(() => {
        // var c = document.getElementById("myCanvas");
        // if (c) {
        //     var ctx = c.getContext("2d");
        //     ctx.moveTo(0, 0);
        //     ctx.lineTo(200, 100);
        //     ctx.stroke();
        // }
        if (!initialised) {
            // console.clear();
            if (window.attach_paper_initialising) return;
            // intialise();
            setTimeout(intialise, 250);
        }
    }, []);

    const intialise = () => {
        if (initialised) return;
        if (window.attach_paper_initialising) return;
        let done = InitialiseCanvas("attachmentCanvas");
        if (done) {
            // let changed = setOffsets();
            // if (!changed)
            DrawAttachment();
            setInitialise(true);
            zoomAll();
            window.attach_paper_initialising = false;
        } else {
            setTimeout(intialise, 250);
            window.attach_paper_initialising = false;
        }
    };

    setTimeout(() => {
        initialise_offsets();
    }, 500);

    React.useEffect(() => {
        if (initialised) {
            setOffsets();
        }
    }, [attachmentTypeVariation]);

    // React.useEffect(() => {
    //     if (
    //         attachmentTypeValue.includes("Flyover") &&
    //         riserHeight > 0 &&
    //         window.timber_height
    //     ) {
    //         let new_v_offset = window.timber_height - (area_height - vOffset) + riserHeight;
    //         setVOffset(new_v_offset);
    //     }
    // }, [riserHeight]);

    React.useEffect(() => {
        if (window.attach_setting_riser) window.attach_setting_riser = false;
        else {
            if (attachmentTypeValue.includes("Flyover") && window.timber_height) {
                // let new_v_offset = window.attach_timber_height - (area_height - vOffset) + riserHeight;
                let newRiserHeight = area_height - window.timber_height;

                let min_riser_height = Math.round(120 / Cos(house_pitch) + 90 + 25 + beam_height);
                let max_riser_height = window.LYSAGHT ? 500 + beam_height : 1000;

                if (newRiserHeight < min_riser_height) newRiserHeight = min_riser_height;
                if (newRiserHeight > max_riser_height) newRiserHeight = max_riser_height;

                setRiserHeight(newRiserHeight);
            }
        }
    }, [attachmentTypeValue, window.timber_height]);

    React.useEffect(() => {
        if (attachmentTypeValue.includes("Flyover")) {
            let attachmentDefinition = attachmentDefinitionRaw;
            if (attachmentTypeVariation && attachmentDefinition?.variations?.[attachmentTypeVariation]) {
                attachmentDefinition = {
                    ...attachmentDefinitionRaw,
                    ...attachmentDefinitionRaw?.variations?.[attachmentTypeVariation],
                };
                if (
                    roofAlignment.includes("Side") &&
                    areaData?.SHAPE?.DesignType === DESIGN_TYPES.GABLE_PORTAL &&
                    attachmentTypeVariation === "Gutter"
                ) {
                    attachmentDefinition.height_offset_max = "Beam_Height-50";
                    attachmentDefinition.height_offset_min = "Beam_Height-50";
                    attachmentDefinition.height_offset_editable_side = false;
                }
            }

            let wall_frame_width = attachmentDefinition?.wall_thickness ? attachmentDefinition?.wall_thickness : 350;
            if (window.LYSAGHT) setHOffset(-(eaveValue + wall_frame_width - 45 + 25));
            else setHOffset(-(eaveValue + wall_frame_width - 45 + 25 + beam_width));
        }
    }, [eaveValue, wallType, riserHeight, attachmentTypeValue, attachmentTypeVariation, brand]);

    React.useEffect(() => {
        if (attachmentTypeValue.includes("Flyover")) {
            if (window.timber_height) {
                window.attach_setting_riser = true;
                let new_v_offset = window.timber_height - (area_height - vOffset) + riserHeight;
                setVOffset(new_v_offset);
            }
        }
    }, [riserHeight]);

    let attachment_length = item && item.lengthQQ ? item.lengthQQ : 6000;
    if (state_attachment_length != null) attachment_length = state_attachment_length;
    //
    let max = attachment_length;

    let data_paat = getItemFromArray(areaDataPartialAttachments, "Ref", ref);

    // let roof_alignment_default = 0;
    // let roofPitch = 0;

    // if (props.attach_tag) ref = props.attach_tag;
    if (ref === "GutterB" || ref === "AttachmentGutterB" || ref === "AttachmentBack" || ref === "AttachmentTop")
        ref = "Back 1";
    if (ref === "GutterF" || ref === "AttachmentGutterF" || ref === "AttachmentFront" || ref === "AttachmentBottom")
        ref = "Front 1";
    if (ref === "GutterL" || ref === "AttachmentGutterL" || ref === "AttachmentLeft") ref = "Left 1";
    if (ref === "GutterR" || ref === "AttachmentGutterR" || ref === "AttachmentRight") ref = "Right 1";

    // let data = getRoofAlignmentAndPitch(ref, areaData);

    if (ref.includes("Right")) roof_alignment_default = "RightSide";
    else if (ref.includes("Left")) roof_alignment_default = "Side";
    else if (ref.includes("Front")) roof_alignment_default = "Front";

    if (ref.startsWith("C")) {
        // let cutout_side = getCutoutSide(ref);

        let cutout_side = "BackRight";
        if (ref.startsWith("CBR")) cutout_side = "BackRight";
        if (ref.startsWith("CBM")) cutout_side = "BackMid";
        if (ref.startsWith("CBL")) cutout_side = "BackLeft";
        if (ref.startsWith("CFL")) cutout_side = "FontLeft";
        if (ref.startsWith("CFR")) cutout_side = "FontRight";
        // return cutout_side;

        let cutout_type = areaData.SHAPE.CUTOUTS?.[cutout_side + "-CutoutType"];

        if (cutout_type === "Angle") {
            //adjust pitch
            let cutout_angle_r = Math.atan(
                areaData.SHAPE.CUTOUTS?.[cutout_side + "-WidthY"] / areaData.SHAPE.CUTOUTS?.[cutout_side + "-WidthX"]
            );
            if (Math.abs(cutout_angle_r) < 0.2) {
                roof_alignment_default = "Back";
            } else {
                if (cutout_side.includes("Right")) roof_alignment_default = "RightSide";
                else if (cutout_side.includes("Left")) roof_alignment_default = "Side";
                roofPitch = roofPitch * Math.sin(cutout_angle_r);
            }
        } else {
            if (ref.includes(" Y")) {
                if (cutout_side.includes("Right")) roof_alignment_default = "RightSide";
                else roof_alignment_default = "Side";

                if (cutout_side.includes("Right")) roof_alignment_default = "RightSide";
                else roof_alignment_default = "Side";
            } else {
                roof_alignment_default = "Back";
            }
        }
    }

    let roofPitch = areaData?.SHAPE?.RoofPitch ? areaData?.SHAPE?.RoofPitch : 5;
    if (
        areaData?.SHAPE?.DesignType === DESIGN_TYPES.GABLE_PORTAL ||
        areaData?.SHAPE?.DesignType === DESIGN_TYPES.PITCHED
    ) {
        roofPitch = -roofPitch;
        if (roof_alignment_default.includes("Side")) roofPitch = 0;
    }

    if (!roofAlignment) roofAlignment = roof_alignment_default;
    if (!roof_pitch) roof_pitch = roofPitch;
    // const [roofAlignment, setRoofAlignment] = React.useState(roof_alignment_default);
    // const [roof_pitch, setRoof_pitch] = React.useState(roofPitch);

    let default_default_attachment_type = Object.keys(ATTACHMENT_TYPES)[0];
    if (!data_mods?.AttachmentType && ref.includes("CBM") && areaDataAttachments.AttachmentTop) {
        let back_data_mods = getItemFromArray(areaDataAttachmentModifications, "Ref", "Back 1");
        if (back_data_mods?.AttachmentType && ATTACHMENT_TYPES?.[back_data_mods?.AttachmentType])
            default_default_attachment_type = back_data_mods?.AttachmentType;
    }

    // let boll = ATTACHMENT_TYPES?.[design_options["default_attachment_type"]];
    if (
        design_options["default_attachment_type"]
        // && ATTACHMENT_TYPES?.[design_options["default_attachment_type"]]
    ) {
        default_default_attachment_type = design_options["default_attachment_type"];
    }

    let default_attachment_type =
        data_mods?.AttachmentType && ATTACHMENT_TYPES?.[data_mods?.AttachmentType]
            ? data_mods?.AttachmentType
            : default_default_attachment_type; //"Fascia with Receiver Channel";

    if (is_deck_mode) default_attachment_type = "Wall";

    function is_attachment_style_allowed(attachment_data, roof_pitch, roofAlignment) {
        if (!attachment_data.allow_for_watershed_side && roof_pitch < 0 && !roofAlignment.includes("Side"))
            return false;

        if (attachment_data?.allow_for_flat === false && areaData?.SHAPE?.DesignType === DESIGN_TYPES.FLAT) {
            return false;
        }

        if (
            attachment_data?.allow_for_gable_side &&
            (areaData?.SHAPE?.DesignType === DESIGN_TYPES.GABLE_PORTAL ||
                areaData?.SHAPE?.DesignType === DESIGN_TYPES.PITCHED) &&
            roofAlignment.includes("Side")
        ) {
            return true;
        }
        if (!attachment_data.allow_on_side && roofAlignment.includes("Side")) return false;
        if (
            !attachment_data?.allow_for_gable &&
            (areaData?.SHAPE?.DesignType === DESIGN_TYPES.GABLE_PORTAL ||
                areaData?.SHAPE?.DesignType === DESIGN_TYPES.PITCHED)
        )
            return false;

        return true;
    }

    if (!is_attachment_style_allowed(ATTACHMENT_TYPES?.[default_attachment_type], roof_pitch, roofAlignment)) {
        for (let attachment in ATTACHMENT_TYPES) {
            if (is_attachment_style_allowed(ATTACHMENT_TYPES?.[attachment], roof_pitch, roofAlignment)) {
                default_attachment_type = attachment;
                break;
            }
        }
    }

    if (is_deck_mode) default_attachment_type = "Wall";

    let initial_attachment_type_value = data_mods?.AttachmentType ? data_mods.AttachmentType : default_attachment_type;
    if (initial_attachment_type_value.includes("Beam") && !initial_attachment_type_value.includes("Wall"))
        initial_attachment_type_value = "Rafter Brackets supporting Beam";

    if (is_deck_mode) initial_attachment_type_value = "Wall";

    if (!ATTACHMENT_TYPES?.[initial_attachment_type_value]) initial_attachment_type_value = default_attachment_type;

    if (!attachmentTypeValue) {
        attachmentTypeValue = initial_attachment_type_value;
        if (attachmentTypeValue !== _attachmentTypeValue) {
            setAttachmentType(attachmentTypeValue);
        }
    }

    // const [attachmentTypeValue, setAttachmentType] = React.useState(initial_attachment_type_value);

    let default_attachment_type_variation = data_mods?.AttachmentVariation ? data_mods?.AttachmentVariation : "";
    if (!ATTACHMENT_TYPES?.[initial_attachment_type_value]?.variations?.[default_attachment_type_variation]) {
        default_attachment_type_variation = "";
        let keys = ATTACHMENT_TYPES?.[default_attachment_type]?.variations
            ? Object.keys(ATTACHMENT_TYPES[default_attachment_type]?.variations)
            : [];
        if (keys.length > 0) default_attachment_type_variation = keys[0];
    }

    if (!attachmentTypeVariation) attachmentTypeVariation = default_attachment_type_variation;
    // const [attachmentTypeVariation, setAttachmentTypeVariation] = React.useState(default_attachment_type_variation);

    let default_attachment_type_data = ATTACHMENT_TYPES?.[default_attachment_type];
    // let attachmentDefinitionRaw = default_attachment_type_data;
    let attachmentDefinitionRaw = ATTACHMENT_TYPES?.[attachmentTypeValue];
    if (!attachmentDefinitionRaw) {
        attachmentDefinitionRaw = default_attachment_type_data;
    }
    // const [attachmentDefinitionRaw, setAttachmentDefinition] = React.useState(default_attachment_type_data);

    let attachmentDefinition = attachmentDefinitionRaw;
    if (attachmentTypeVariation && attachmentDefinition?.variations?.[attachmentTypeVariation]) {
        attachmentDefinition = {
            ...attachmentDefinitionRaw,
            ...attachmentDefinitionRaw?.variations?.[attachmentTypeVariation],
        };

        if (
            roofAlignment.includes("Side") &&
            areaData?.SHAPE?.DesignType === DESIGN_TYPES.GABLE_PORTAL &&
            attachmentTypeVariation === "Gutter"
        ) {
            attachmentDefinition.height_offset_max = "Beam_Height-50";
            attachmentDefinition.height_offset_min = "Beam_Height-50";
            attachmentDefinition.height_offset_editable_side = false;
        }
    }

    const roof_sheet_top_colour = "#c12121";
    // const roof_on_side = true;
    let eaveWidth = 600;
    const fasciaHeight = 188;
    const houseGutterWidth = 125;
    // let wall_height = 2100;
    // const house_pitch = 22.5;
    // const area_height = 2100;
    const beam_width = window.LYSAGHT ? 50 : 65;
    // const beam_height = window.LYSAGHT ? 150 : 158;

    let beam = areaData[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType1;
    if (roof_alignment_default.includes("Side")) beam = areaData[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType3;
    if (
        areaData.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL ||
        areaData?.SHAPE?.DesignType === DESIGN_TYPES.PITCHED
    )
        beam = areaData[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType3;

    let beam_height = GetBeamHeight(beam);

    let min = item?.min_unattached_left ? toNumber(item?.min_unattached_left) : 0;
    if (item?.min_unattached_right) max = max - toNumber(item?.min_unattached_right);
    let p1 = min;
    let p2 = max;

    let min_attachment_length = 0;
    let min_attachment_length_helpertext = "";
    if (attachmentTypeValue.includes("Flyover") || attachmentTypeValue.includes("Rafter Brackets")) {
        min_attachment_length = JobExistingStructure?.RoofType === "Tile" ? 600 : 900;
        if (attachmentTypeValue.includes("Flyover")) {
            min_attachment_length_helpertext = "min attachment length for Flyover is " + min_attachment_length + "mm";
        } else if (attachmentTypeValue.includes("Rafter Brackets")) {
            min_attachment_length_helpertext =
                "min attachment length for Rafter Brackets is " + min_attachment_length + "mm";
        } else {
            min_attachment_length_helpertext = "min attachment length is " + min_attachment_length + "mm";
        }
        if (JobExistingStructure?.RoofType) {
            min_attachment_length_helpertext += " for a " + JobExistingStructure?.RoofType + " roof.";
        }
    }

    if (data_paat) {
        if (data_paat.Kind === "NAN") {
            p1 = data_paat.Offset;
            p2 = data_paat.Offset + data_paat.Length;
        } else if (data_paat.Kind === "AN") {
            p1 = 0;
            p2 = data_paat.Length;
        } else {
            p1 = max - data_paat.Length;
            p2 = max;
        }
    }
    if (p1 < min) p1 = min;
    if (p2 > max) p2 = max;

    let paatValues = [p1, p2];
    if (state_paatValues) paatValues = state_paatValues;

    const handlePaatValuesChange = (event, newValue) => {
        if (newValue[0] < min) newValue[0] = min;
        if (newValue[1] > max) newValue[1] = max;
        if (min_attachment_length > 0) {
            if (newValue[1] - newValue[0] < min_attachment_length) {
                if (newValue[0] > attachment_length - min_attachment_length) {
                    newValue[0] = attachment_length - min_attachment_length;
                } else {
                    newValue[1] = newValue[0] + min_attachment_length;
                }
            }
        }
        setPaatValues(newValue);
    };

    let paatGutterValue = data_paat ? data_paat.HasGutter === 0 : false;
    if (state_paatGutterValue) paatValues = state_paatGutterValue;

    let min_rafters = 2; // as only for flyover now...
    let spacing = 6100;

    if (attachmentTypeValue.includes("Flyover") || (!data_mods && default_FasciaType.includes("Flyover"))) {
        if (SiteParameters?.FlyoverBracketSpacing) spacing = SiteParameters?.FlyoverBracketSpacing;
    } else if (SiteParameters?.RafterBracketSpacing) {
        spacing = SiteParameters?.RafterBracketSpacing;
    }

    const attach_length = paatValues[1] - paatValues[0];
    let recommended_brackets = Math.trunc((attach_length ? attach_length : attachment_length) / spacing + 0.999999) + 1;
    let max_rafters = min_rafters * 3;
    if (max_rafters < 10) max_rafters = 12;

    let num_brackets = 0;
    if (data_mods && data_mods.NumBrackets) num_brackets = data_mods.NumBrackets;
    if (num_brackets < min_rafters) num_brackets = 0;
    if (num_brackets > max_rafters) num_brackets = max_rafters;

    if (!(attachmentTypeValue.includes("Flyover") || default_FasciaType.includes("Flyover"))) {
        if (data_mods && data_mods.NumBrackets) data_mods.NumBrackets = 0;
        num_brackets = 0;
    }

    let rafterBracketMenuItems = [];
    rafterBracketMenuItems.push(<MenuItem value={0}>Auto</MenuItem>);
    for (let step = min_rafters; step < max_rafters + 1; step++) {
        rafterBracketMenuItems.push(
            <MenuItem value={step}>
                {step}
                {step === recommended_brackets ? " (Recommended)" : ""}
            </MenuItem>
        );
    }

    let gutter_tag = "GutterB";
    if (ref.includes("Back")) gutter_tag = "GutterB";
    if (ref.includes("Front")) gutter_tag = "GutterF";
    if (ref.includes("Left")) gutter_tag = "GutterL";
    if (ref.includes("Right")) gutter_tag = "GutterR";
    let side_has_double_gutter = areaData?.[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES]?.[gutter_tag] > 0;

    let numBrackets = num_brackets;
    if (state_numBrackets !== null) numBrackets = state_numBrackets;

    let rSBLC = data_mods ? data_mods.AllowRSBLC === 1 : false;
    if (state_rSBLC !== null) rSBLC = state_rSBLC;

    let extendAttachmentToSheetEnd =
        data_mods?.ExtendAttachmentToSheetEnd !== undefined ? data_mods.ExtendAttachmentToSheetEnd === 1 : true;
    if (state_extendAttachmentToSheetEnd !== null) extendAttachmentToSheetEnd = state_extendAttachmentToSheetEnd;

    let partialAttachmentFasciaBeamFlush =
        data_paat?.PartialAttachmentFasciaBeamFlush !== undefined
            ? data_paat.PartialAttachmentFasciaBeamFlush === 1
            : false;
    if (state_partialAttachmentFasciaBeamFlush !== null)
        partialAttachmentFasciaBeamFlush = state_partialAttachmentFasciaBeamFlush;

    let fasciaIsRaked = data_mods?.FasciaIsRaked !== undefined ? data_mods.FasciaIsRaked === 1 : false;
    if (state_fasciaIsRaked !== null) fasciaIsRaked = state_fasciaIsRaked;

    let leftCantilever = data_mods?.LeftCantilever !== undefined ? data_mods.LeftCantilever : 0;
    if (state_leftCantilever !== null) leftCantilever = state_leftCantilever;

    let rightCantilever = data_mods?.RightCantilever !== undefined ? data_mods.RightCantilever : 0;
    if (state_rightCantilever !== null) rightCantilever = state_rightCantilever;

    const handleRSBLC = (event, newValue) => {
        setRSBLC(newValue);
    };

    const handleClose = () => {
        window.timber_height = null;
        onCancel();
    };

    const handleListItemClick = (value) => {
        onCancel(value);
    };

    const handleDelete = () => {
        window.timber_height = null;
        setPaatValues([0, max]);
        setPaatGutterValue(false);
        setAttachmentLabel("");
        setEaveValue(default_EaveDepth);
        setWallHeight(default_WallHeight);
        setAttachmentType(default_attachment_type);
        setnumBrackets(0);
        setRSBLC(false);
        setExtendAttachmentToSheetEnd(true);
        setPartialAttachmentFasciaBeamFlush(false);
        // dispatch(deleteFromAreaSpecificationModificationArray(item.areaIndex, "ATTACHMENTS.PARTIAL_ATTACHMENTS", ref, false));
        // dispatch(deleteFromAreaSpecificationModificationArray(item.areaIndex, "ATTACHMENTS.AttachmentModifications", ref, true));
        // onClose();
    };

    const handleUnattach = () => {
        if (attach_tag) {
            let cutout = attach_tag.startsWith("Back") || attach_tag.startsWith("Back");
            let attachment_section = cutout ? BASIC_SPECS_SECTIONS.SHAPE : BASIC_SPECS_SECTIONS.ATTACHMENTS;

            dispatch(
                updateAreaSpecificationJob(item.areaIndex, attachment_section, cutout ? "CUTOUTS" : null, attach_tag, 0)
            );

            onCancel();
        }
    };

    const setOffsets = () => {
        let variation = ATTACHMENT_TYPES?.[attachmentTypeValue]?.variations?.[attachmentTypeVariation];

        if (variation) {
            let offsets = getOffsets(
                attachmentDefinition,
                beam_height,
                roof_sheet_height,
                eaveValue,
                roofAlignment,
                vOffset,
                hOffset
            );
            offsets = adjustOffsetForSide(ref, offsets, roofAlignment, areaData);
            let new_h_offset = offsets.h;
            let new_v_offset = offsets.v;

            // if (variation?.depth_offset_default !== undefined) {
            //     if (typeof variation?.depth_offset_default === "string") {
            //         if (variation?.depth_offset_default.includes("150-Beam_Width")) {
            //             new_h_offset = 150 - beam_width;
            //         }
            //     } else {
            //         new_h_offset = toNumber(variation?.depth_offset_default);
            //     }
            // }

            // if (variation?.height_offset_default === "Beam_Height") new_v_offset = beam_height ? beam_height : 0;
            // else if (variation?.height_offset_default === "Beam_Height-50")
            //     new_v_offset = beam_height ? beam_height - 50 : 0;
            // else if (variation?.height_offset_default === "-Sheet_Height")
            //     new_v_offset = roof_sheet_height ? -roof_sheet_height : 0;
            // else if (variation?.height_offset_default)
            //     new_v_offset = toNumber(variation?.height_offset_default ? variation?.height_offset_default : 0);

            let changed = false;
            if (new_h_offset !== hOffset) {
                changed = true;
                setHOffset(new_h_offset);
            }
            if (new_v_offset !== vOffset) {
                changed = true;
                setVOffset(new_v_offset);
            }
            return changed;
        }
        return false;
    };

    const initialise_offsets = () => {
        if (initialised) {
            setOffsets();
        } else {
            setTimeout(initialise_offsets, 500);
        }
    };

    const DrawAttachment = () => {
        window.attach_paper2.activate();
        let paper = window.attach_paper2;

        paper.project.activeLayer.removeChildren();

        let baseFontSize = 65;

        let roof_pitch_to_use = roof_pitch;
        if (roofAlignment.includes("Right")) roof_pitch_to_use = -roof_pitch;
        if (roofAlignment.includes("Front")) roof_pitch_to_use = -roof_pitch;

        let roof_sheet_length = roofAlignment.includes("Side") ? attachment_length : 1500;
        let side_length = attachment_length;
        let roof_sheet_thickness = roof_sheet_height;
        let roof_line_width = 20;
        let roof_drop = Sin(roof_pitch_to_use) * roof_sheet_length;
        if (Math.abs(roof_drop) < 10) roof_drop = roof_sheet_thickness;
        let roof_horizontal = roofAlignment.includes("Side") ? 1500 : Cos(roof_pitch_to_use) * roof_sheet_length;

        let pitching_point_adj = 0;
        if (roofAlignment.includes("Right")) pitching_point_adj = -roof_drop;
        if (roofAlignment.includes("Front")) pitching_point_adj = -Sin(roof_pitch_to_use) * areaData?.SHAPE?.Depth;

        // dims
        // let fasciaHeightOffset = 110 + roof_sheet_thickness;
        let fasciaHeightOffset = 110;
        let fasciaWidth = 30;
        let wall_width = 110;
        let eave_upoffset = 25;
        let eaveWidth = eaveValue;
        let backchannel_height = roof_sheet_thickness + 10;
        let backchannel_length = 50;

        let gutter_height_back = 70;
        let gutter_height_front = 90;
        let gutter_width = 125;

        let house_roof_length = 900;
        if (eaveWidth > 490) house_roof_length = (eaveWidth + 300) / Cos(house_pitch);

        if (brand === "Lysaght") window.LYSAGHT = true;
        else window.LYSAGHT = false;

        let local_pitching_height = area_height;

        if (areaData?.SHAPE?.DesignType === DESIGN_TYPES.GABLE_PORTAL) {
            local_pitching_height += beam_height;
        }

        let wall_height = local_pitching_height + fasciaHeightOffset - fasciaHeight + eave_upoffset - vOffset;
        let wall_height_extend = roof_drop < -300 ? Math.abs(roof_drop) + 200 : 500;

        let wall_only = attachmentDefinition?.wall_only !== undefined ? attachmentDefinition?.wall_only : false;

        let hasBeam = attachmentDefinition?.has_beam !== undefined ? attachmentDefinition?.has_beam : false;

        let rafter_brackets = false;
        if (attachmentTypeValue.includes("Rafter Brackets")) rafter_brackets = true;
        let elevation = 0;

        if (attachmentTypeVariation.includes("Riser")) elevation = vOffset;
        if (rafter_brackets && roofAlignment.includes("Side")) elevation = vOffset;

        let roof_line_style = {
            strokeColor: "black",
            dashArray: [15, 30],
            strokeWidth: roof_sheet_thickness,
            strokeCap: "butt",
        };

        let from;
        let to;

        if (window.debug) {
            from = new paper.Point(-300, 0);
            to = from.add(new paper.Point(600, 0));
            let cross = new paper.Path.Line(from, to);
            cross.style = {
                strokeColor: "#AA5555",
                dashArray: [5, 10],
                strokeWidth: 40,
                strokeCap: "butt",
            };
            from = new paper.Point(0, -300);
            to = from.add(new paper.Point(0, 600));
            cross = new paper.Path.Line(from, to);
            cross.style = {
                strokeColor: "#AA5555",
                dashArray: [5, 10],
                strokeWidth: 40,
                strokeCap: "butt",
            };
        }

        // pitching height dim
        from = new paper.Point(hOffset, -vOffset);
        to = from.add(new paper.Point(600, 0));
        if (attachmentTypeValue.includes("Flyover")) to = from.add(new paper.Point(-200, 0));
        if (roofAlignment.includes("Front")) {
            from = new paper.Point(hOffset + 600 + 600, -vOffset);
            to = from.add(new paper.Point(-600, 0));
        }
        let path = new paper.Path.Line(from, to);
        to = to.add(new paper.Point(0, area_height));
        path.add(to);
        // to = to.add(new paper.Point(-1000 - eaveWidth, 0));
        // path.add(to);
        path.style = {
            strokeColor: "grey",
            dashArray: [5, 10],
            strokeWidth: 10,
            strokeCap: "butt",
        };

        // area height dimension
        from = new paper.Point(650 + hOffset, area_height / 2 - vOffset);
        if (attachmentTypeValue.includes("Flyover")) from = new paper.Point(hOffset - 250, area_height / 2 - vOffset);
        // if (attachmentTypeValue.includes("Flyover")) from = new paper.Point(-hOffset + 200, area_height / 2 - vOffset);
        var text = new paper.PointText(from);
        text.justification = "left";
        if (attachmentTypeValue.includes("Flyover")) text.justification = "right";
        text.fontSize = baseFontSize + "px";
        text.fillColor = "black";
        text.content = "Area Pitching Height: \n" + "(Underside of Sheet)\n" + area_height + "mm";
        if (areaData?.SHAPE?.DesignType === DESIGN_TYPES.GABLE_PORTAL) {
            path.position.y += beam_height;
            text.content = "Area Pitching Height: \n" + "(Underside of Edge Beam)\n" + area_height + "mm";
        }

        if (vOffset > 0 && !wall_only && !attachmentTypeValue.includes("Flyover")) {
            // fascia pitching height dimension

            let fascia_pitching_height = local_pitching_height - vOffset;
            from = new paper.Point(0, 0);
            to = from.add(new paper.Point(hOffset + 75, 0));
            let path = new paper.Path.Line(from, to);
            to = to.add(new paper.Point(0, fascia_pitching_height));
            path.add(to);
            // to = to.add(new paper.Point02(-1000 - eaveWidth, 0));
            // path.add(to);
            path.style = {
                strokeColor: "grey",
                dashArray: [5, 10],
                strokeWidth: 10,
                strokeCap: "butt",
            };

            from = new paper.Point(hOffset + 125, wall_height / 2 - 250);
            // if (attachmentTypeValue.includes("Flyover")) from = new paper.Point(-hOffset + 200, area_height / 2 - vOffset);
            var text = new paper.PointText(from);
            text.justification = "left";
            text.fontSize = baseFontSize * 0.8 + "px";
            text.fillColor = "black";
            text.content = "Fascia\nPitching\nHeight: \n" + fascia_pitching_height.toFixed(0) + "mm";
        }

        if (attachmentTypeValue.includes("Flyover")) {
            // pitching height dim over fascia
            // from = new paper.Point(hOffset, -vOffset);
            // to = from.add(new paper.Point(-hOffset + 200, 0));
            // let path = new paper.Path.Line(from, to);
            // to = to.add(new paper.Point(0, vOffset));
            // path.add(to);
            // to = to.add(new paper.Point(-200, 0));
            // path.add(to);
            // // to = to.add(new paper.Point(-1000 - eaveWidth, 0));
            // // path.add(to);
            // path.style = {
            //     strokeColor: "grey",
            //     dashArray: [5, 10],
            //     strokeWidth: 10,
            //     strokeCap: "butt",
            // };
            // // area height dimension
            // var text = new paper.PointText(new paper.Point(250, -vOffset / 2));
            // text.justification = "left";
            // text.fontSize = "55px";
            // text.fillColor = "black";
            // text.content = "Height Offset from Fascia: \n" + vOffset.toFixed(0) + "mm";
            // from = new paper.Point(0, 0);
            // to = from.add(new paper.Point(0, -vOffset - 100));
            // path = new paper.Path.Line(from, to);
            // to = to.add(new paper.Point(hOffset, 0));
            // path.add(to);
            // to = to.add(new paper.Point(0, 100));
            // path.add(to);
            // path.style = {
            //     strokeColor: "grey",
            //     dashArray: [5, 10],
            //     strokeWidth: 10,
            //     strokeCap: "butt",
            // };
            // // area height dimension
            // var text = new paper.PointText(new paper.Point(hOffset / 2, -vOffset - 200));
            // text.justification = "center";
            // text.fontSize = "55px";
            // text.fillColor = "black";
            // text.content = "Depth Offset from Fascia: \n" + Math.abs(hOffset) + "mm";
        }

        // ground
        from = new paper.Point(hOffset + 1100, local_pitching_height - vOffset);
        to = from.add(new paper.Point(-1100 - eaveWidth - 500, 0));
        if (attachmentTypeValue.includes("Flyover")) to = from.add(new paper.Point(-1100 - 200, 0));
        if (wall_only) to = from.add(new paper.Point(-1100 - 400 - hOffset, 0));
        path = new paper.Path.Line(from, to);
        path.style = {
            strokeColor: "#553333",
            strokeWidth: 20,
            strokeCap: "butt",
        };

        if (roofAlignment.includes("Side")) {
            if (
                (areaData.SHAPE.DesignType === DESIGN_TYPES.GABLE_PORTAL ||
                    areaData?.SHAPE?.DesignType === DESIGN_TYPES.PITCHED) &&
                roofAlignment.includes("Side")
            ) {
                let rise_pnt = (attachment_length / 2) * Sin(areaData?.SHAPE?.RoofPitch);
                roof_sheet_thickness = rise_pnt;
            }

            // roof line
            // from = new paper.Point(100, -100);
            from = new paper.Point(hOffset, pitching_point_adj - vOffset - roof_sheet_thickness * 0.5 + roof_drop / 2);
            // if (roof_pitch_to_use < 0) {
            //     from = new paper.Point(hOffset, -vOffset + roof_drop / 2);
            // }
            to = from.add(new paper.Point(1000, 0));
            // to = new paper.Point(1000, 0);
            let path = new paper.Path.Line(from, to);
            path.style = {
                strokeColor: {
                    gradient: {
                        stops: [roof_sheet_top_colour, shadeColor(roof_sheet_top_colour, -30)],
                    },
                    //origin and destination defines the direction of your gradient. In this case its vertical i.e bottom(blue/cooler) to up(red/warmer) refering to link you sent.
                    origin: [0, 200], //gradient will start applying from y=200 towards y=0. Adjust this value to get your desired result
                    destination: [0, 0],
                },
                dashArray: [15, 5],
                strokeWidth: Math.abs(roof_drop) + roof_sheet_thickness,
                strokeCap: "butt",
            };

            // from = new paper.Point(0, drop + 100);
            // to = new paper.Point(roof_sheet_length, drop + 100);
            // let path2 = new paper.Path.Line(new paper.Point(0, drop), new paper.Point(0, drop));
            // path2.style = roof_line_style;
        } else {
            // roof line
            from = new paper.Point(hOffset, -vOffset + vDisplayOffset - roof_sheet_thickness * 0.5);
            if (roofAlignment.includes("Front"))
                from = new paper.Point(hOffset, pitching_point_adj - vOffset - roof_sheet_thickness * 0.5);

            to = from.add(
                new paper.Point(roof_sheet_length * Cos(roof_pitch_to_use), roof_sheet_length * Sin(roof_pitch_to_use))
            );

            let into_gutter = false;
            if (attachmentDefinition?.allow_for_watershed_side && roof_pitch_to_use < 0) into_gutter = true;
            // if (!window.LYSAGHT && attachmentTypeValue.includes("Flyover")) into_gutter = true;
            if (into_gutter) {
                from = to.add(
                    new paper.Point(
                        -(roof_sheet_length + 50) * Cos(roof_pitch_to_use),
                        -(roof_sheet_length + 50) * Sin(roof_pitch_to_use)
                    )
                );
            }
            path = new paper.Path.Line(from, to);
            path.style = roof_line_style;
            path.strokeColor = roof_sheet_top_colour;
        }

        // let path2 = new paper.Path.Line(from + new paper.Point(0, 20), to + new paper.Point(0, 20));
        // path2.style = roof_line_style;

        if (rafter_brackets) {
            let rafter_length = 1100;
            let beam_offset = elevation > 0 ? beam_width : 0;
            from = new paper.Point(hOffset + beam_offset, bracket_width / 2);
            to = from.add(new paper.Point(-hOffset - beam_offset, 0));
            let rafter_bracket = new paper.Path.Line(from, to);
            rafter_bracket.strokeWidth = bracket_width;
            rafter_bracket.strokeColor = "darkgrey";

            from = new paper.Point(-fasciaWidth, bracket_width / 2);
            to = from.add(new paper.Point(-rafter_length * Cos(house_pitch), -rafter_length * Sin(house_pitch)));
            let rafter_bracket2 = new paper.Path.Line(from, to);
            rafter_bracket2.strokeWidth = bracket_width;
            rafter_bracket2.strokeColor = "darkgrey";
        }

        if (rafter_brackets || attachmentTypeVariation.includes("Riser")) {
            if (elevation > 0) {
                from = new paper.Point(hOffset + beam_width + bracket_width / 2, bracket_width);
                to = from.add(new paper.Point(0, -vOffset - bracket_width));
                let rafter_bracket2 = new paper.Path.Line(from, to);
                rafter_bracket2.strokeWidth = bracket_width;
                rafter_bracket2.strokeColor = "darkgrey";

                if (eaveWidth > 80) {
                    var text = new paper.PointText(
                        new paper.Point(hOffset + beam_width + bracket_width / 2 + 60, -vOffset / 2)
                    );
                    text.justification = "left";
                    text.fontSize = baseFontSize + 10 + "px";
                    text.fillColor = "black";
                    text.content = vOffset.toFixed(0) + "mm";
                }
            }
        }

        if (wall_only) {
            eaveWidth = 0;
            fasciaHeightOffset = wall_height_extend;
            wall_height = local_pitching_height + wall_height_extend;
        } else {
            // eave
            let from2 = new paper.Point(0, -fasciaHeightOffset + fasciaHeight - eave_upoffset);
            let result = from2.add(new paper.Point(-eaveWidth, 0));
            let eave = new paper.Path.Line(from2, result);
            eave.strokeColor = "black";
            eave.strokeWidth = 5;

            // fascia
            let fascia_type =
                attachmentDefinition?.fascia_type !== undefined ? attachmentDefinition?.fascia_type : "Timber Fascia";
            if (fascia_type === "Steel Fascia") {
                from = new paper.Point(-fasciaWidth, -fasciaHeightOffset);
                to = from.add(new paper.Point(fasciaWidth - 5, 0));
                let fascia = new paper.Path.Line(from, to);
                to = to.add(new paper.Point(0, fasciaHeight));
                fascia.add(to);
                to = to.add(new paper.Point(-fasciaWidth, 0));
                fascia.add(to);
                to = to.add(new paper.Point(0, -20));
                fascia.add(to);
                fascia.strokeColor = "#8888aa";
                fascia.strokeWidth = 10;
            } else {
                from = new paper.Point(-fasciaWidth / 2, -fasciaHeightOffset);
                to = new paper.Point(-fasciaWidth / 2, -fasciaHeightOffset + fasciaHeight);
                let fascia = new paper.Path.Line(from, to);
                fascia.strokeColor = "#975a08";
                fascia.strokeWidth = fasciaWidth;
            }

            //house roof:
            from = new paper.Point(40, -fasciaHeightOffset + 0);
            to = from.add(
                new paper.Point(
                    -(house_roof_length + 100) * Cos(house_pitch),
                    -(house_roof_length + 100) * Sin(house_pitch)
                )
            );
            let house_roof = new paper.Path.Line(from, to);
            house_roof.strokeColor = "#4b4b58";
            house_roof.strokeWidth = 30;

            // rafter
            let rafter_length = 800;
            let purlin_height_offset = +35 / Cos(22.5);

            let steel_fascia_offset = 0;
            if (eaveWidth > 490) rafter_length = (eaveWidth + 250) / Cos(house_pitch);
            from = new paper.Point(-fasciaWidth - 3, -fasciaHeightOffset + purlin_height_offset);

            if (fascia_type === "Steel Fascia") {
                steel_fascia_offset = fasciaWidth - 10;
                from = from.add(
                    new paper.Point(steel_fascia_offset * Cos(house_pitch), steel_fascia_offset * Sin(house_pitch))
                );
                purlin_height_offset += 6;
            }

            let to2 = from.add(new paper.Point(-rafter_length * Cos(house_pitch), -rafter_length * Sin(house_pitch)));
            let house_rafter = new paper.Path.Line(to2, from);
            to = from.add(new paper.Point(0, fasciaHeight - eave_upoffset - 10 - purlin_height_offset));
            house_rafter.add(to);
            to = to.add(new paper.Point(-45, 0));
            let eave_box_from = to;
            house_rafter.add(to);
            to = to.add(
                new paper.Point(-(rafter_length - 35) * Cos(house_pitch), -(rafter_length - 35) * Sin(house_pitch))
            );
            house_rafter.add(to);
            house_rafter.strokeColor = "#b78a38";
            house_rafter.strokeWidth = 10;

            // let rafter_height = +120 / Cos(22.5);

            // from = new paper.Point(-fasciaWidth - 3, -fasciaHeightOffset + purlin_height_offset);
            // to2 = from.add(new paper.Point(-rafter_length * Cos(house_pitch), -rafter_length * Sin(house_pitch)));
            // house_rafter = new paper.Path.Line(to2, from);
            // to = from.add(new paper.Point(0, rafter_height));
            // house_rafter.add(to);
            // to = to.add(
            //     new paper.Point(-(rafter_length - 35) * Cos(house_pitch), -(rafter_length - 35) * Sin(house_pitch))
            // );
            // house_rafter.add(to);
            // house_rafter.strokeColor = "#b78a38";
            // house_rafter.strokeWidth = 10;

            let offset = 55 + 40;
            if (attachmentDefinition?.wall_type === "Timber Frame") offset = 0;

            if (house_pitch > 10) {
                to = eave_box_from.add(new paper.Point(-eaveWidth - offset, 0));
                let eave_box = new paper.Path.Line(eave_box_from, to);
                to = to.add(new paper.Point(0, -90));
                eave_box.add(to);
                to = to.add(new paper.Point(eaveWidth + offset - 90 / Tan(house_pitch), 0));
                eave_box.add(to);
                eave_box.strokeColor = "#c7aa58";
                eave_box.strokeWidth = 10;
            }

            // house gutter
            from = new paper.Point(12, -gutter_height_back - 20);
            to = from.add(new paper.Point(0, gutter_height_back));
            let gutter = new paper.Path.Line(from, to);
            to = to.add(new paper.Point(gutter_width - 10, 0));
            gutter.add(to);
            to = to.add(new paper.Point(10, -10));
            gutter.add(to);
            to = to.add(new paper.Point(0, -gutter_height_front + 5));
            gutter.add(to);
            to = to.add(new paper.Point(-10, 0));
            gutter.add(to);
            gutter.strokeColor = "#666666";
            gutter.strokeWidth = 10;

            if (attachmentTypeVariation.includes("Gutter")) {
                // house gutter
                // let gutter_height_back = 60;
                // let gutter_height_front = 90;
                // let gutter_width = 125;
                from = new paper.Point(25 + gutter_width + 8 + gutter_width, -gutter_height_back - 20);
                to = from.add(new paper.Point(0, gutter_height_back));
                let gutter = new paper.Path.Line(from, to);
                to = to.add(new paper.Point(-gutter_width + 10, 0));
                gutter.add(to);
                to = to.add(new paper.Point(-10, -10));
                gutter.add(to);
                to = to.add(new paper.Point(0, -gutter_height_front + 5));
                gutter.add(to);
                to = to.add(new paper.Point(10, 0));
                gutter.add(to);
                gutter.strokeColor = "#666666";
                gutter.strokeWidth = 10;
            }
        }

        // backchannel
        if (hasBC) {
            let bc_from = new paper.Point(
                5 + backchannel_length / 2,
                pitching_point_adj //-roof_sheet_thickness -+ backchannel_height / 2 - vOffset
            );

            if (roofAlignment.includes("Side")) {
                let bc2_from = bc_from.add(new paper.Point(-backchannel_length / 2 + 10, -5));
                let bc_to = bc2_from.add(new paper.Point(0, roof_drop));
                let backchannel = new paper.Path.Line(bc2_from, bc_to);
                backchannel.strokeColor = "black";
                backchannel.strokeWidth = backchannel_length / 2 + 5;

                bc2_from = bc_from.add(new paper.Point(0, roof_drop));
                bc_to = bc2_from.add(new paper.Point(-backchannel_length / 2, 0));
                backchannel = new paper.Path.Line(bc2_from, bc_to);
                backchannel.add(bc_to.add(new paper.Point(0, backchannel_height)));
                backchannel.add(bc_to.add(new paper.Point(backchannel_length, backchannel_height)));
                backchannel.strokeColor = "black";
                backchannel.strokeWidth = backchannel_length;
            }

            if (!roofAlignment.includes("Side")) {
                let bc_to = bc_from.add(new paper.Point(-backchannel_length / 2, 0));
                let backchannel = new paper.Path.Line(bc_from, bc_to);
                backchannel.add(bc_to.add(new paper.Point(0, backchannel_height)));
                backchannel.add(bc_to.add(new paper.Point(backchannel_length, backchannel_height)));
                backchannel.strokeColor = "black";
                backchannel.strokeWidth = 15;
            }
        }

        // beam
        if (hasBeam) {
            let beam_h_offset = beam_width / 2;
            let beam_v_offset = 0;
            if (rafter_brackets && elevation === 0) {
                // beam_h_offset = 0;
                beam_v_offset = 10;
            }
            if (roofAlignment.includes("Side")) {
                beam_v_offset = roof_drop;
                // beam_v_offset = roof_drop + roof_sheet_height * 0.5;
            }

            // if (!window.LYSAGHT && attachmentTypeValue.includes("Flyover")) beam_h_offset = -25; // riser width/2
            from = new paper.Point(hOffset + beam_h_offset - 5, pitching_point_adj - vOffset + beam_v_offset);
            // if (attachmentTypeValue.includes("Wall Direct to Beam")) {
            //     from = new paper.Point(hOffset + beam_width / 2 - 10, -vOffset + backchannel_height / 2 + 10);
            // }
            to = from.add(new paper.Point(0, beam_height));
            let beam = new paper.Path.Line(from, to);
            beam.strokeWidth = beam_width;
            beam.strokeColor = "grey";

            //cross

            let b1 = from.add(new paper.Point(-beam_width / 2, 0));
            let b2 = from.add(new paper.Point(beam_width / 2, 0));
            let b3 = to.add(new paper.Point(-beam_width / 2, 0));
            let b4 = to.add(new paper.Point(beam_width / 2, 0));

            let beam_x1 = new paper.Path.Line(b1, b4);
            beam_x1.strokeWidth = 4;
            beam_x1.strokeColor = "black";
            let beam_x2 = new paper.Path.Line(b2, b3);
            beam_x2.strokeWidth = 4;
            beam_x2.strokeColor = "black";

            if (
                (attachmentTypeValue.includes("Flyover") || attachmentTypeVariation.includes("Riser")) &&
                !roofAlignment.includes("Side") &&
                roof_pitch_to_use < 0
            ) {
                // structure gutter
                from = new paper.Point(hOffset - 15, -vOffset + 5);
                to = from.add(new paper.Point(0, gutter_height_back));
                let gutter = new paper.Path.Line(from, to);
                to = to.add(new paper.Point(-gutter_width + 10, 0));
                gutter.add(to);
                to = to.add(new paper.Point(-10, -10));
                gutter.add(to);
                to = to.add(new paper.Point(0, -gutter_height_front + 5));
                gutter.add(to);
                to = to.add(new paper.Point(10, 0));
                gutter.add(to);
                gutter.strokeColor = "#666666";
                gutter.strokeWidth = 10;
            }
        }

        // eave dimension
        if (eaveWidth > 80) {
            var text = new paper.PointText(new paper.Point(-eaveWidth / 2, -fasciaHeightOffset + fasciaHeight + 100));
            text.justification = "center";
            text.fontSize = baseFontSize + "px";
            text.fillColor = "black";
            text.content = eaveWidth.toFixed(0) + "mm";
        }

        // // wall
        let has_brickwall = true;
        let timber_wall_cladding = false;
        let wall_skin_thickness = 110;
        let wall_cavity_thickness = 40;
        if (attachmentTypeValue.includes("Flyover") && attachmentDefinition?.wall_type === "Timber Frame") {
            has_brickwall = false;
            wall_skin_thickness = 0;
            wall_cavity_thickness = 0;

            from = new paper.Point(-eaveWidth + 18 / 2, -fasciaHeightOffset + fasciaHeight - 2 - eave_upoffset);
            to = from.add(new paper.Point(0, wall_height));
            let timber_frame_cladding = new paper.Path.Line(from, to);
            timber_frame_cladding.strokeColor = "#876a28";
            timber_frame_cladding.strokeWidth = 18;
        } else if (
            attachmentDefinition?.wall_type === "Timber Frame" ||
            (attachmentTypeValue.includes("Offset") && wallType === "Timber Frame")
        ) {
            has_brickwall = false;
            timber_wall_cladding = wall_only;
            if (timber_wall_cladding) wall_skin_thickness = 18;
            else wall_skin_thickness = 0;
            wall_cavity_thickness = 0;
        }

        if (has_brickwall) {
            let url = BaseURL("images/attach_brick.jpg");
            // url = "http://localhost:3000/app/images/attach_brick.jpg";
            // url = "http://assets.paperjs.org/images/marilyn.jpg";
            let raster = new paper.Raster(url);
            raster.position = new paper.Point(
                -eaveWidth - wall_width / 2,
                -fasciaHeightOffset + fasciaHeight - 2 + wall_height / 2 - eave_upoffset
            );
            if (wall_only) {
                raster.position = new paper.Point(
                    -eaveWidth - wall_width / 2,
                    wall_height / 2 - wall_height_extend - vOffset
                );
            }
            raster.size = new paper.Size(wall_width, wall_height);
            raster.onLoad = function () {
                raster.size = new paper.Size(wall_width, wall_height);
            };
        } else if (timber_wall_cladding) {
            from = new paper.Point(-eaveWidth - wall_skin_thickness / 2, -wall_height_extend - vOffset);
            to = from.add(new paper.Point(0, wall_height));
            let timber_frame_cladding = new paper.Path.Line(from, to);
            timber_frame_cladding.strokeColor = "#876a28";
            timber_frame_cladding.strokeWidth = wall_skin_thickness;
        }

        // timber wall
        let timber_wall_thickness = 90;
        let extra_timber_height =
            (eaveWidth + wall_skin_thickness + wall_cavity_thickness + timber_wall_thickness) * Tan(house_pitch);

        if (attachmentTypeValue.includes("Flyover")) {
            // add riser BK50/JUMBO
            if (window.LYSAGHT)
                from = new paper.Point(hOffset + bracket_width / 2, pitching_point_adj - vOffset + beam_height + 10);
            else from = new paper.Point(hOffset + bracket_width / 2 + beam_width, pitching_point_adj - vOffset);

            if (roofAlignment.includes("Side")) from = from.add(new paper.Point(0, roof_drop));

            to = from.add(new paper.Point(0, vOffset - roof_drop));
            let rafter_bracket2 = new paper.Path.Line(from, to);
            rafter_bracket2.strokeWidth = bracket_width;
            rafter_bracket2.strokeColor = "darkgrey";
        }

        // timber wall

        if (wall_only) {
            from = new paper.Point(
                -eaveWidth - wall_skin_thickness - wall_cavity_thickness - timber_wall_thickness / 2,
                -wall_height_extend - vOffset
            );
            to = from.add(new paper.Point(0, wall_height));
        } else {
            from = new paper.Point(
                -eaveWidth - wall_skin_thickness - wall_cavity_thickness - timber_wall_thickness / 2,
                +fasciaHeight - fasciaHeightOffset - extra_timber_height
            );
            to = from.add(new paper.Point(0, wall_height + extra_timber_height - eave_upoffset));
        }

        let timber_frame = new paper.Path.Line(from, to);
        var timber_height = Math.abs(to.y - from.y);
        window.timber_height = timber_height;
        timber_frame.strokeColor = "#b78a38";
        timber_frame.strokeWidth = timber_wall_thickness;

        //cross
        let b1 = from.add(new paper.Point(-timber_wall_thickness / 2, 0));
        let b2 = from.add(new paper.Point(timber_wall_thickness / 2, 0));
        let b3 = from.add(new paper.Point(-timber_wall_thickness / 2, 45));
        let b4 = from.add(new paper.Point(timber_wall_thickness / 2, 45));

        let timber_x1 = new paper.Path.Line(b1, b2);
        timber_x1.add(b4);
        timber_x1.add(b3);
        timber_x1.add(b1);
        timber_x1.add(b4);
        timber_x1.add(b3);
        timber_x1.add(b2);
        timber_x1.strokeWidth = 4;
        timber_x1.strokeColor = "black";
        // let timber_x2 = new paper.Path.Line(b2, b3);
        // timber_x2.strokeWidth = 4;
        // timber_x2.strokeColor = "black";

        from = from.add(new paper.Point(-(timber_wall_thickness / 2) - 5, 0));
        to = to.add(new paper.Point(-(timber_wall_thickness / 2) - 5, 0));
        let gyprock = new paper.Path.Line(from, to);
        gyprock.strokeColor = "#EEEEEE";
        gyprock.strokeWidth = 10;

        from = from.add(new paper.Point(-5, 0));
        to = to.add(new paper.Point(-5, 0));
        let gyprock_line = new paper.Path.Line(from, to);
        gyprock_line.strokeColor = "#444444";
        gyprock_line.strokeWidth = 2;

        if (attachmentTypeValue.includes("Flyover")) {
            // area height dimension lines
            to = from.add(new paper.Point(200, 0));
            path = new paper.Path.Line(from, to);
            to = new paper.Point(to.x, -vOffset);
            path.add(to);
            to = to.add(new paper.Point(-200, 0));
            path.add(to);
            path.style = {
                strokeColor: "grey",
                dashArray: [5, 10],
                strokeWidth: 10,
                strokeCap: "butt",
            };

            // area height dimension
            let text = new paper.PointText(new paper.Point(hOffset - 200, -(vOffset / 2) - 180));
            text.justification = "right";
            text.fontSize = baseFontSize + "px";
            text.fillColor = "black";
            text.content = "Height Above Top Plate:\n" + (local_pitching_height - timber_height).toFixed(0) + "mm ";
            window.local_pitching_height = local_pitching_height - timber_height;
            window.height_above_topplate = local_pitching_height - timber_height;

            to = from.add(new paper.Point(200, 0));
            path = new paper.Path.Line(from, to);
            to = new paper.Point(to.x, -vOffset);
            path.add(to);
            path.style = {
                strokeColor: "grey",
                dashArray: [5, 10],
                strokeWidth: 10,
                strokeCap: "butt",
            };

            //timber frame dim

            to = from.add(new paper.Point(350, 0));
            path = new paper.Path.Line(from, to);
            // to = new paper.Point(to.x, timber_height);
            to = to.add(new paper.Point(0, timber_height));
            path.add(to);
            path.style = {
                strokeColor: "grey",
                dashArray: [5, 10],
                strokeWidth: 10,
                strokeCap: "butt",
            };

            // timber height dimension
            // var text2 = from.add(new paper.Point(400, -timber_height / 2));
            // var text2 = to.add(new paper.Point(50, timber_height / 2));
            let text2 = new paper.PointText(new paper.Point(hOffset + 400, +(timber_height / 2) - 200));
            text2.justification = "left";
            text2.fontSize = "55px";
            text2.fillColor = "black";
            text2.content = "Timber Frame Height: \n" + timber_height.toFixed(0) + "mm";
        }

        let offset_bracket = false;
        if (attachmentTypeValue.includes("Offset")) offset_bracket = true;
        if (offset_bracket) {
            let bracket_width = 50;
            from = new paper.Point(0, bracket_width * 0.5);
            to = from.add(new paper.Point(hOffset, 0));
            let offset_bracket = new paper.Path.Line(from, to);
            offset_bracket.strokeWidth = bracket_width;
            offset_bracket.strokeColor = "darkgrey";

            // house gutter
            // let box_gutter_height = 60;
            // let box_gutter_width = 125;
            from = new paper.Point(hOffset - 15, -vOffset);
            to = from.add(new paper.Point(0, gutter_height_back));
            let gutter = new paper.Path.Line(from, to);
            to = to.add(new paper.Point(-gutter_width + 10, 0));
            gutter.add(to);
            to = to.add(new paper.Point(-10, -10));
            gutter.add(to);
            to = to.add(new paper.Point(0, -gutter_height_front + 5));
            gutter.add(to);
            to = to.add(new paper.Point(10, 0));
            gutter.add(to);
            gutter.strokeColor = "#666666";
            gutter.strokeWidth = 10;

            // to = from.add(new paper.Point(-15, -5));
            // let box_gutter = new paper.Path.Line(from, to);
            // to = to.add(new paper.Point(0, box_gutter_height + 30));
            // box_gutter.add(to);
            // to = to.add(new paper.Point(box_gutter_width - 10, 0));
            // box_gutter.add(to);
            // to = to.add(new paper.Point(0, -box_gutter_height));
            // box_gutter.add(to);
            // to = to.add(new paper.Point(-15, 5));
            // box_gutter.add(to);
            // box_gutter.strokeColor = "#666666";
            // box_gutter.strokeWidth = 10;
        }

        // FRONT VIEW

        if (roof_horizontal < 2000) roof_horizontal = 2000;
        let FRONT_ORIGIN = new paper.Point(roof_horizontal + hOffset + 200, 0);
        let FRONT_ORIGIN_ATTACHMENT = new paper.Point(roof_horizontal + hOffset + 200, 0);

        let paat_p1 = toNumber(paatValues[0]);
        let paat_p2 = toNumber(paatValues[1]);

        let overall_side_length = side_length;
        let paat_part2_offset = overall_side_length - paat_p2;
        //Partial Attachment
        //

        if (paatValues[0] > 0) {
            // let unattached_height = wall_height + (house_roof_length + 100) * Cos(house_pitch);
            let wall_height_extend_unattached = house_roof_length * Sin(house_pitch) + fasciaHeight;
            from = new paper.Point(FRONT_ORIGIN.x, -wall_height_extend_unattached / 2 + wall_height / 2);
            to = from.add(new paper.Point(paat_p1, 0));
            // let wall_unattached = new paper.Path.Line(from, to);
            // wall_unattached.strokeColor = "#44444444";
            // wall_unattached.strokeWidth = wall_height + wall_height_extend_unattached;
            // wall_unattached.strokeWidth = wall_height + wall_height_extend_unattached;
            // wall_unattached.style = {
            //     strokeColor: "#AAAAAA",
            //     // dashArray: [30, 10],
            //     strokeWidth: wall_height + wall_height_extend_unattached,
            //     strokeCap: "butt",
            // };
            // wall_unattached.style = {
            //     strokeColor: "#BBCCBB",
            //     dashArray: [40, 80],
            //     strokeWidth: wall_height + wall_height_extend_unattached,
            //     strokeCap: "butt",
            // };

            FRONT_ORIGIN_ATTACHMENT.x = FRONT_ORIGIN_ATTACHMENT.x + paat_p1;

            side_length = side_length - paat_p1 - paat_part2_offset;
            from = new paper.Point(
                FRONT_ORIGIN_ATTACHMENT.x + side_length,
                -wall_height_extend_unattached / 2 + wall_height / 2
            );
            to = from.add(new paper.Point(paat_part2_offset, 0));
            // let wall_unattached_2 = new paper.Path.Line(from, to);
            // wall_unattached_2.strokeColor = "#44444444";
            // wall_unattached.strokeWidth = wall_height + wall_height_extend_unattached;
            // wall_unattached.strokeWidth = wall_height + wall_height_extend_unattached;
            // wall_unattached.style = {
            //     strokeColor: "#AAAAAA",
            //     // dashArray: [30, 10],
            //     strokeWidth: wall_height + wall_height_extend_unattached,
            //     strokeCap: "butt",
            // };
            // wall_unattached_2.style = {
            //     strokeColor: "#BBCCBB",
            //     dashArray: [40, 80],
            //     strokeWidth: wall_height + wall_height_extend_unattached,
            //     strokeCap: "butt",
            // };
        } else {
            side_length = side_length - paat_p1 - paat_part2_offset;
        }

        // FRONT_ORIGIN = new paper.Point(-500, 0);

        if (!wall_only) {
            // from = new paper.Point(40, -fasciaHeightOffset + 0);
            // to = from.add(
            //     new paper.Point(
            //         -(house_roof_length + 40) * Cos(house_pitch),
            //         -(house_roof_length + 40) * Sin(house_pitch)
            //     )
            // );
            // let house_roof = new paper.Path.Line(from, to);
            // house_roof.strokeColor = "#4b4b58";
            // house_roof.strokeWidth = 30;

            //roof sheet

            let house_roof_drop = (house_roof_length + 100) * Sin(house_pitch);
            from = new paper.Point(FRONT_ORIGIN_ATTACHMENT.x, -fasciaHeightOffset - house_roof_drop / 2);
            to = from.add(new paper.Point(side_length, 0));
            // to = new paper.Point(1000, 0);
            let house_roof = new paper.Path.Line(from, to);
            house_roof.style = {
                strokeColor: {
                    gradient: {
                        stops: ["#6b6b78", shadeColor("#6b6b78", -30)],
                    },
                    //origin and destination defines the direction of your gradient. In this case its vertical i.e bottom(blue/cooler) to up(red/warmer) refering to link you sent.
                    origin: [0, 200], //gradient will start applying from y=200 towards y=0. Adjust this value to get your desired result
                    destination: [0, 0],
                },
                dashArray: [15, 5],
                strokeWidth: house_roof_drop,
                strokeCap: "butt",
            };
        }

        //wall
        from = new paper.Point(FRONT_ORIGIN_ATTACHMENT.x, -fasciaHeightOffset + fasciaHeight / 2 + wall_height / 2);
        if (wall_only)
            from = new paper.Point(FRONT_ORIGIN_ATTACHMENT.x, -wall_height_extend - vOffset + wall_height / 2);
        to = from.add(new paper.Point(side_length, 0));
        let wall = new paper.Path.Line(from, to);
        wall.strokeColor = "#bbbbbb";
        wall.strokeWidth = wall_height;

        if (!wall_only) {
            // fascia
            let fascia_type =
                attachmentDefinition?.fascia_type !== undefined ? attachmentDefinition?.fascia_type : "Timber Fascia";
            if (fascia_type === "Steel Fascia") {
                // from = new paper.Point(-fasciaWidth, -fasciaHeightOffset);
                // to = from.add(new paper.Point(fasciaWidth - 5, 0));
                // let fascia = new paper.Path.Line(from, to);
                // to = to.add(new paper.Point(0, fasciaHeight));
                // fascia.add(to);
                // to = to.add(new paper.Point(-fasciaWidth, 0));
                // fascia.add(to);
                // to = to.add(new paper.Point(0, -20));
                // fascia.add(to);
                // fascia.strokeColor = "#8888aa";
                // fascia.strokeWidth = 10;
                from = new paper.Point(FRONT_ORIGIN_ATTACHMENT.x, -fasciaHeightOffset + fasciaHeight / 2);
                to = from.add(new paper.Point(side_length, 0));
                let fascia = new paper.Path.Line(from, to);
                fascia.strokeColor = "#555555";
                fascia.strokeWidth = fasciaHeight;
            } else {
                from = new paper.Point(FRONT_ORIGIN_ATTACHMENT.x, -fasciaHeightOffset + fasciaHeight / 2);
                to = from.add(new paper.Point(side_length, 0));
                let fascia = new paper.Path.Line(from, to);
                fascia.strokeColor = "#975a08";
                fascia.strokeWidth = fasciaHeight;
            }
            // house gutter
            from = new paper.Point(FRONT_ORIGIN_ATTACHMENT.x, -fasciaHeightOffset + 20);
            to = from.add(new paper.Point(side_length, 0));
            let gutter = new paper.Path.Line(from, to);
            gutter.strokeColor = "#aaaaaa";
            gutter.strokeWidth = gutter_height_front + 15;
        }

        //beam
        if (hasBeam) {
            if (roofAlignment.includes("Side")) {
                from = new paper.Point(FRONT_ORIGIN.x, pitching_point_adj - vOffset + beam_height / 2 + roof_drop);
                to = from.add(new paper.Point(overall_side_length, -roof_drop));
                let beam = new paper.Path.Line(from, to);
                beam.style = {
                    strokeColor: "#666666",
                    strokeWidth: beam_height,
                    strokeCap: "butt",
                };
            } else {
                from = new paper.Point(FRONT_ORIGIN.x, pitching_point_adj - vOffset + beam_height / 2);
                to = from.add(new paper.Point(overall_side_length, 0));
                let beam = new paper.Path.Line(from, to);
                beam.style = {
                    strokeColor: "#666666",
                    strokeWidth: beam_height,
                    strokeCap: "butt",
                };
            }
        }

        // rafter brackets

        let backet_spacing =
            JobExistingStructure.RoofType === "Steel"
                ? attachmentDefinition?.bracket_spacing_sheet
                    ? attachmentDefinition?.bracket_spacing_sheet
                    : 900
                : attachmentDefinition?.bracket_spacing_tile
                ? attachmentDefinition?.bracket_spacing_tile
                : 1200;

        if (backet_spacing === "FlyoverBracketSpacing") backet_spacing = SiteParameters.FlyoverBracketSpacing;

        let num_brackets_to_draw = Math.trunc(side_length / backet_spacing) + 1;

        if (numBrackets > 0) num_brackets_to_draw = numBrackets - 1;

        let spacing = (side_length - 50) / num_brackets_to_draw;

        //

        let has_riser = attachmentTypeVariation.includes("Riser") || attachmentTypeValue.includes("Rafter Brackets");
        if (rafter_brackets) {
            for (let i = 0; i < num_brackets_to_draw + 1; i++) {
                from = new paper.Point(FRONT_ORIGIN_ATTACHMENT.x + 25 + i * spacing, 0);

                let up = elevation;
                if (roofAlignment.includes("Side")) {
                    if (paat_part2_offset > 0) up = elevation - paat_part2_offset * Tan(roof_pitch_to_use);
                    // up = elevation - (roof_drop - (roof_drop / num_brackets) * i);
                    up = up - (num_brackets_to_draw - i) * spacing * Tan(roof_pitch_to_use) - pitching_point_adj;
                    if (up < beam_height / 3) continue;
                    // else if (up < -(beam_height / 2)) continue;
                    if (has_riser && up < 0) continue;
                    if (up > beam_height / 2 && !has_riser) {
                        up += beam_height;
                    }
                    if (up < beam_height / 2) up = beam_height / 2;
                }
                if (from.x - FRONT_ORIGIN.x < paat_p1 || from.x - FRONT_ORIGIN.x > paat_p2) continue;
                to = from.add(new paper.Point(0, -Math.max(50, up)));
                let bracket = new paper.Path.Line(from, to);
                bracket.style = {
                    strokeColor: "black",
                    strokeWidth: 50,
                    strokeCap: "butt",
                };
                if (up > (window.LYSAGHT ? 450 : 500)) {
                    bracket.strokeColor = "red";
                }
            }
        } else if (attachmentTypeValue.includes("Offset Brackets")) {
            if (elevation > 0) {
                for (let i = 0; i < num_brackets_to_draw + 1; i++) {
                    from = new paper.Point(FRONT_ORIGIN_ATTACHMENT.x + 25 + i * spacing, 0);
                    // if (roofAlignment.includes("Right")) elevation = roof_drop;
                    let up = elevation;
                    if (roofAlignment.includes("Side")) {
                        if (paat_part2_offset > 0) up = elevation - paat_part2_offset * Tan(roof_pitch_to_use);
                        // up = elevation - (roof_drop - (roof_drop / num_brackets) * i);
                        up = up - (num_brackets_to_draw - i) * spacing * Tan(roof_pitch_to_use) - pitching_point_adj;
                        if (up < beam_height / 3) continue;
                        // else if (up < -(beam_height / 2)) continue;
                        if (has_riser && up < 0) continue;
                        if (up > beam_height / 2 && !has_riser) {
                            up += beam_height;
                        }
                        if (up < beam_height / 2) up = beam_height / 2;

                        from = new paper.Point(
                            FRONT_ORIGIN_ATTACHMENT.x + 25 + i * spacing,
                            -elevation +
                                (num_brackets_to_draw - i) * spacing * Tan(roof_pitch_to_use) +
                                paat_part2_offset * Tan(roof_pitch_to_use)
                        );

                        if (roofAlignment.includes("Right")) {
                            from.y -= roof_drop;
                        }
                    } else if (roofAlignment.includes("Front")) {
                        from.y = 0;
                        up = -(pitching_point_adj - vOffset);
                    }
                    if (from.x - FRONT_ORIGIN.x < paat_p1 || from.x - FRONT_ORIGIN.x > paat_p2) continue;

                    if (roofAlignment.includes("Right")) {
                        to = from.add(new paper.Point(0, Math.max(50, up)));
                    } else if (roofAlignment.includes("Side")) {
                        to = from.add(new paper.Point(0, Math.max(50, up)));
                    } else {
                        to = from.add(new paper.Point(0, -Math.max(50, up)));
                    }

                    let bracket = new paper.Path.Line(from, to);
                    bracket.style = {
                        strokeColor: "black",
                        strokeWidth: 50,
                        strokeCap: "butt",
                    };
                    if (up > (window.LYSAGHT ? 450 : 500)) {
                        bracket.strokeColor = "red";
                    }
                }
            } else {
                for (let i = 0; i < num_brackets_to_draw + 1; i++) {
                    from = new paper.Point(FRONT_ORIGIN_ATTACHMENT.x + 25 + i * spacing, 0);
                    if (roofAlignment.includes("Side")) {
                        if (roofAlignment.includes("Right")) elevation = roof_drop;
                        from = new paper.Point(
                            FRONT_ORIGIN_ATTACHMENT.x + 25 + i * spacing,
                            -elevation +
                                (num_brackets_to_draw - i) * spacing * Tan(roof_pitch_to_use) +
                                paat_part2_offset * Tan(roof_pitch_to_use)
                        );
                    }
                    if (from.x - FRONT_ORIGIN.x < paat_p1 || from.x - FRONT_ORIGIN.x > paat_p2) continue;
                    to = from.add(new paper.Point(0, -50));
                    let bracket = new paper.Path.Line(from, to);
                    bracket.style = {
                        strokeColor: "black",
                        strokeWidth: 50,
                        strokeCap: "butt",
                    };
                }
            }
        } else if (attachmentTypeValue.includes("Offset Brackets")) {
            for (let i = 0; i < num_brackets_to_draw + 1; i++) {
                from = new paper.Point(FRONT_ORIGIN_ATTACHMENT.x + 25 + i * spacing, 0);

                let up = elevation;
                if (roofAlignment.includes("Side")) {
                    if (roofAlignment.includes("Right")) elevation = roof_drop;
                    if (paat_part2_offset > 0) up = elevation - paat_part2_offset * Tan(roof_pitch_to_use);
                    // up = elevation - (roof_drop - (roof_drop / num_brackets) * i);
                    up = up - (num_brackets_to_draw - i) * spacing * Tan(roof_pitch_to_use) - pitching_point_adj;
                    if (up < beam_height / 3) continue;
                    // else if (up < -(beam_height / 2)) continue;
                    if (has_riser && up < 0) continue;
                    if (up > beam_height / 2 && !has_riser) {
                        up += beam_height;
                    }
                    if (up < beam_height / 2) up = beam_height / 2;

                    from = new paper.Point(
                        FRONT_ORIGIN_ATTACHMENT.x + 25 + i * spacing,
                        -elevation +
                            (num_brackets_to_draw - i) * spacing * Tan(roof_pitch_to_use) +
                            paat_part2_offset * Tan(roof_pitch_to_use)
                    );
                }
                if (from.x - FRONT_ORIGIN.x < paat_p1 || from.x - FRONT_ORIGIN.x > paat_p2) continue;

                if (roofAlignment.includes("Side")) {
                    to = from.add(new paper.Point(0, Math.max(50, up)));
                } else {
                    to = from.add(new paper.Point(0, -Math.max(50, up)));
                }
                let bracket = new paper.Path.Line(from, to);
                bracket.style = {
                    strokeColor: "black",
                    strokeWidth: 50,
                    strokeCap: "butt",
                };
            }
        } else if (attachmentTypeValue.includes("Flyover")) {
            for (let i = 0; i < num_brackets_to_draw + 1; i++) {
                from = new paper.Point(FRONT_ORIGIN_ATTACHMENT.x + 25 + i * spacing, -vOffset);
                to = from.add(new paper.Point(0, local_pitching_height - timber_height));

                if (roofAlignment.includes("Side")) {
                    let bracket_drop = (num_brackets_to_draw - 0 - i) * spacing * Tan(roof_pitch_to_use);
                    if (paat_part2_offset > 0) bracket_drop = bracket_drop + paat_part2_offset * Tan(roof_pitch_to_use);
                    if (roofAlignment.includes("Right")) {
                        bracket_drop = i * spacing * Tan(roof_pitch);
                        if (paat_p1 > 0) bracket_drop = bracket_drop + paat_p1 * Tan(roof_pitch);
                    }
                    // bracket_drop = 0;
                    from = new paper.Point(FRONT_ORIGIN_ATTACHMENT.x + 25 + i * spacing, -vOffset + bracket_drop);
                    to = from.add(new paper.Point(0, local_pitching_height - timber_height - bracket_drop));
                }
                if (window.LYSAGHT) {
                    from = from.add(new paper.Point(0, beam_height));
                }
                if (from.x - FRONT_ORIGIN.x < paat_p1 || from.x - FRONT_ORIGIN.x > paat_p2) continue;

                let height = to.y - from.y;
                if (window.LYSAGHT) height += beam_height;
                if (height < 0) continue;

                let bracket = new paper.Path.Line(from, to);
                bracket.style = {
                    strokeColor: "black",
                    strokeWidth: 50,
                    strokeCap: "butt",
                };

                let min_riser_height = Math.round((120 + 35 + 30) / Cos(house_pitch));

                if (height < min_riser_height + beam_height) bracket.strokeColor = "red";
                if (height > (window.LYSAGHT ? 650 : 1000)) bracket.strokeColor = "red";

                // );

                // to = from.add(new paper.Point(0, area_height - timber_height));
                from = to.add(new paper.Point(0, -min_riser_height));
                let bracket_in_roof = new paper.Path.Line(from, to);
                bracket_in_roof.style = {
                    strokeColor: "orange",
                    strokeWidth: 50,
                    dashArray: [5, 5],
                    strokeCap: "butt",
                };
            }
        }

        //roof sheet
        if (
            (areaData.SHAPE.DesignType === DESIGN_TYPES.GABLE_PORTAL ||
                areaData?.SHAPE?.DesignType === DESIGN_TYPES.PITCHED) &&
            roofAlignment.includes("Side")
        ) {
            //gable end, just add a triangle

            let from = new paper.Point(
                FRONT_ORIGIN.x,
                pitching_point_adj - vOffset + roof_drop - roof_sheet_height * 0.5
            );
            let rise_pnt = (overall_side_length / 2) * Sin(areaData?.SHAPE?.RoofPitch);
            to = from.add(new paper.Point(overall_side_length / 2, -rise_pnt));

            path = new paper.Path.Line(from, to);
            path.add(from.add(new paper.Point(overall_side_length, 0)));
            path.strokeWidth = beam_height;
            path.strokeColor = "darkgrey";
        } else if (roofAlignment.includes("Side")) {
            if (hasBC) {
                // backchannel

                let from = new paper.Point(
                    FRONT_ORIGIN.x,
                    pitching_point_adj - vOffset + vDisplayOffset + roof_drop - roof_sheet_height * 0.5
                );
                to = from.add(new paper.Point(overall_side_length, -roof_drop));

                path = new paper.Path.Line(from, to);
                path.strokeWidth = roof_sheet_thickness;
                path.strokeColor = "black";
            }

            // roof line

            let from = new paper.Point(
                FRONT_ORIGIN.x,
                pitching_point_adj - vOffset + roof_drop - roof_sheet_height * 0.5
            );
            to = from.add(new paper.Point(overall_side_length, -roof_drop));

            path = new paper.Path.Line(from, to);
            path.style = roof_line_style;
            path.strokeColor = roof_sheet_top_colour;
        } else {
            from = new paper.Point(FRONT_ORIGIN.x, -vOffset - backchannel_height / 2 + roof_drop / 2);
            if (roofAlignment.includes("Front"))
                from = new paper.Point(
                    FRONT_ORIGIN.x,
                    pitching_point_adj - vOffset - backchannel_height / 2 + roof_drop / 2
                );
            // if (roof_pitch_to_use < 0) {
            //     from = new paper.Point(FRONT_ORIGIN.x, -vOffset + roof_drop / 2 - 20);
            // }
            to = from.add(new paper.Point(overall_side_length, 0));
            // to = new paper.Point(1000, 0);
            let verandah_roof = new paper.Path.Line(from, to);
            verandah_roof.style = {
                strokeColor: {
                    gradient: {
                        stops: [roof_sheet_top_colour, shadeColor(roof_sheet_top_colour, -30)],
                    },
                    //origin and destination defines the direction of your gradient. In this case its vertical i.e bottom(blue/cooler) to up(red/warmer) refering to link you sent.
                    origin: [0, 200], //gradient will start applying from y=200 towards y=0. Adjust this value to get your desired result
                    destination: [0, 0],
                },
                dashArray: [15, 2],
                strokeWidth: Math.max(roof_sheet_thickness, Math.abs(roof_drop)),
                strokeCap: "butt",
            };

            if (hasBC) {
                // backchannel
                from = new paper.Point(FRONT_ORIGIN_ATTACHMENT.x, -vOffset - backchannel_height / 2 - 10);
                to = from.add(new paper.Point(side_length, 0));
                let backchannel = new paper.Path.Line(from, to);
                backchannel.style = {
                    strokeColor: "black",
                    strokeWidth: 20,
                    strokeCap: "butt",
                };
            }
        }

        // let rafter_brackets = false;
        // if (attachmentTypeValue.includes("Rafter Brackets")) rafter_brackets = true;
        // let elevation = 0;
        // if (attachmentTypeValue.includes("Riser")) elevation = vOffset;)

        // let url2 = "http://assets.paperjs.org/images/marilyn.jpg";
        // let raster2 = new paper.Raster(url2);
        // // raster2.position = new paper.Point(-eaveWidth - wall_width, fasciaHeightOffset + wall_height / 2);
        // raster2.size = new paper.Size(110, 2400);

        // raster.size = new paper.Size(1000, 1000);
        // var group = new paper.Group();
        // group.addChild(wall);
        // group.addChild(raster);
        // group.clipped = true;
        // group.clipMask = true;

        // var rect = new paper.Rectangle();
        //  // { x: 0, y: 0, width: 0, height: 0 }

        // // Now we can for example define its size...
        // rect.size = new paper.Size(100, 200);

        // // and its center
        // rect.center = new paper.Point(100, 100);
        // rect.fillColor = "#ff0000";
        //  // { x: 0, y: 0, width: 0, height: 0 }

        // var meterStart = new paper.Point(5, 5);
        // var meterSize = new paper.Size(200, 2400);
        // var meter = new paper.Path.Rectangle(meterStart, meterSize);
        // meter.strokeColor = "black";
        // meter.fillColor = "#ff0000";
        // meter.strokeWidth = 50;

        // wall.clipMask = true;

        // var url = "http://assets.paperjs.org/images/marilyn.jpg";
        // var raster = new paper.Raster(url);
        // raster.position = new paper.Point(300, 300);

        // var group = new paper.Group();
        // group.addChild(raster);
        // group.addChild(wall);

        // zoomAll();
    };

    const saveAttachmentModifications = () => {
        window.timber_height = null;
        if (area_height !== areaData?.SHAPE?.Height) {
            let error = dispatch(updateAreaSpecificationShape(item.areaIndex, null, "Height", area_height));
            if (error && error.error) {
                dispatch(APP.showDialogData(error));
            }
        }

        let new_data_paat = data_paat ? { ...data_paat } : {};
        new_data_paat.Ref = ref;
        new_data_paat.Name = ref;
        let p1 = paatValues[0];
        let p2 = paatValues[1];
        let attach_length = p2 - p1;
        if (attach_length >= attachment_length) {
            //delete paat from list
            dispatch(
                deleteFromAreaSpecificationModificationArray(
                    item.areaIndex,
                    "ATTACHMENTS.PARTIAL_ATTACHMENTS",
                    ref,
                    false
                )
            );
        } else {
            if (p1 > 0 && p2 >= attachment_length - 10) {
                new_data_paat.Kind = "NA";
                new_data_paat.Length = attach_length;
                new_data_paat.Offset = p1;
            } else if (p1 <= 10) {
                new_data_paat.Kind = "AN";
                new_data_paat.Length = attach_length;
                new_data_paat.Offset = p1;
            } else {
                new_data_paat.Kind = "NAN";
                new_data_paat.Length = attach_length;
                new_data_paat.Offset = p1;
            }
            new_data_paat.HasGutter = paatGutterValue ? 0 : 1;
            new_data_paat.HasBeam = 1;
            new_data_paat.PartialAttachmentFasciaBeamFlush = partialAttachmentFasciaBeamFlush ? 1 : 0;

            dispatch(
                updateAreaSpecificationModificationArray(
                    item.areaIndex,
                    "ATTACHMENTS.PARTIAL_ATTACHMENTS",
                    ref,
                    null,
                    new_data_paat,
                    false
                )
            );
        }

        let new_data_mods = data_mods ? { ...data_mods } : {};
        new_data_mods.Ref = ref;
        new_data_mods.Name = ref;

        new_data_mods.WallOnly = wall_only ? 1 : 0;
        new_data_mods.EaveWidth = isNaN(eaveValue) ? "" : Number(eaveValue);
        new_data_mods.HasEaveWidth =
            new_data_mods.EaveWidth !== "" && new_data_mods.EaveWidth !== default_EaveDepth ? 1 : 0;
        new_data_mods.AttachmentLabel = attachmentLabel;
        let attachment_data = attachmentDefinition;

        let wall_height = area_height - vOffset - 100;

        if (attachment_data?.old_key) {
            new_data_mods.AttachmentType = attachmentTypeValue;
            new_data_mods.FasciaType = attachment_data?.old_key;
        } else {
            new_data_mods.AttachmentType = attachmentTypeValue;
            new_data_mods.FasciaType = attachmentTypeValue;
        }
        new_data_mods.AttachmentVariation = attachmentTypeVariation;

        new_data_mods.WallHeight = isNaN(wall_height) ? "" : Number(wall_height);
        if (ref.includes("Back")) {
            dispatch(
                updateSiteParameters(
                    SITE_PARAMETER_SECTIONS.ExistingStructure + ".WallHeight",
                    new_data_mods.WallHeight
                )
            );
        }
        new_data_mods.HasWallHeight =
            new_data_mods.WallHeight !== "" && new_data_mods.WallHeight !== default_WallHeight ? 1 : 0;

        new_data_mods.vOffset = vOffset;
        new_data_mods.hOffset = hOffset;
        new_data_mods.RoofAlignment = roofAlignment;
        new_data_mods.FasciaIsRaked = fasciaIsRaked ? 1 : 0;

        // let fasciaTypeValue = "Timber Fascia Drop";

        // if (config?.attachment_types?.[attachmentTypeValue]) {
        //     let attachmentType = config?.attachment_types?.[attachmentTypeValue];
        //     if (attachmentType?.has_beam) {
        //         fasciaTypeValue = "Beam";
        //     }
        //     if (attachmentType?.to_wall) {
        //         fasciaTypeValue = "Wall";
        //     }
        // }

        // if (attachmentTypeValue === "") fasciaTypeValue = "";

        // } else {
        //     attachment_options.push({
        //         Key: "",
        //         Display: "Default (" + default_FasciaType + ")",
        //     });
        //     attachment_options.push({
        //         Key: "Timber Fascia Drop",
        //         Display: "Timber Fascia",
        //     });
        //     attachment_options.push({
        //         Key: "Metal Fascia Drop",
        //         Display: "Metal Fascia",
        //     });
        //     attachment_options.push({
        //         Key: "Beam",
        //         Display: "Beam",
        //     });
        //     attachment_options.push({
        //         Key: "Riser",
        //         Display: "Riser",
        //     });
        //     attachment_options.push({
        //         Key: "Wall",
        //         Display: "Wall",
        //     });
        // }

        new_data_mods.HasFasciaType = new_data_mods.FasciaType !== "" ? 1 : 0;
        new_data_mods.NumBrackets = isNaN(numBrackets) ? 0 : Number(numBrackets);
        if (!new_data_mods.NumBrackets) new_data_mods.NumBrackets = 0;
        if (new_data_mods.NumBrackets > max_rafters) new_data_mods.NumBrackets = max_rafters;
        if (new_data_mods.NumBrackets < min_rafters) new_data_mods.NumBrackets = 0;
        if (!(attachmentTypeValue.includes("Flyover") || default_FasciaType.includes("Flyover"))) {
            new_data_mods.NumBrackets = 0;
            num_brackets = 0;
        }

        new_data_mods.HasNumBrackets =
            new_data_mods.NumBrackets !== "" && new_data_mods.NumBrackets >= min_rafters ? 1 : 0;
        new_data_mods.AllowRSBLC = rSBLC ? 1 : 0;

        new_data_mods.ExtendAttachmentToSheetEnd = extendAttachmentToSheetEnd ? 1 : 0;
        new_data_mods.LeftCantilever = leftCantilever;
        new_data_mods.RightCantilever = rightCantilever;

        if (
            new_data_mods.HasEaveWidth ||
            new_data_mods.HasWallHeight ||
            new_data_mods.HasFasciaType ||
            new_data_mods.HasNumBrackets ||
            new_data_mods.AttachmentLabel !== ""
        ) {
            dispatch(
                updateAreaSpecificationModificationArray(
                    item.areaIndex,
                    "ATTACHMENTS.AttachmentModifications",
                    ref,
                    null,
                    new_data_mods,
                    true
                )
            );
        } else {
            //delete paat from list
            dispatch(
                deleteFromAreaSpecificationModificationArray(
                    item.areaIndex,
                    "ATTACHMENTS.AttachmentModifications",
                    ref,
                    true
                )
            );
        }

        onSave();
    };

    // MODS

    // Name:"Back 1",
    // HasEaveWidth:0,
    // EaveWidth:35,
    // HasWallHeight:0,
    // WallHeight:2500,
    // HasFasciaType:0,
    // FasciaType:"Beam",
    // AttachmentLabel:"werwer",
    // HasNumBrackets:1,
    // NumBrackets:44,
    // HasBracketType:0,
    // AllowRSBLC:1,

    const handleAttachmentLabel = (event, newValue) => {
        setAttachmentLabel(newValue !== undefined ? newValue : event.target.value);
    };
    const handleWallHeight = (event, newValue) => {
        setWallHeight(newValue !== undefined ? newValue : event.target.value);
    };
    const handleAttachmentType = (event, newValue) => {
        let value = newValue !== undefined ? newValue.props.value : event.target.value;

        if (attachmentTypeValue.includes("Wall") && !value.includes("Wall") && eaveValue < 1)
            setEaveValue(default_EaveDepth);
        setAttachmentType(value);
    };

    // let min_rafters = Math.trunc((attach_length + 2300) / 2400) + 1;
    // if (window.debug) min_rafters = 1;
    // let tile_spacing = 1200;
    // let recommended_tile = Math.trunc((attach_length + tile_spacing - 50) / tile_spacing) + 1;
    // let sheet_Spacing = 900;
    // let recommended_sheet = Math.trunc((attach_length + sheet_Spacing - 50) / sheet_Spacing) + 1;
    // let max_rafters = min_rafters * 3;
    // if (max_rafters < 10) max_rafters = 12;

    // const handleChange = (event, newValue) => {
    //   setValue(newValue);
    // };

    let attsch_length_display = attachDisplay;
    if (attsch_length_display === null || attsch_length_display === undefined) attsch_length_display = attach_length;

    function AirbnbThumbComponent(props) {
        const classes = useStyles();
        const [thisValue, setThisValue] = React.useState(props["aria-valuenow"]);

        let display_value = thisValue;
        if (display_value === null && props["aria-valuenow"]) display_value = props["aria-valuenow"];

        const data_index = props["data-index"];

        return (
            <span
                {...props}
                style={{
                    ...props.style,
                    borderWidth: "3px",
                    borderColor: data_index == 0 ? "darkgreen" : "darkred",
                    borderStyle: "dotted",
                }}
            >
                <input
                    type="text"
                    id="standard-basic"
                    label=""
                    value={display_value}
                    className={classes.handleText}
                    onMouseDown={(e) => e.stopPropagation()}
                    onChange={(e) => setThisValue(e.target.value)}
                    onBlur={() => {
                        let new_value = [...paatValues];
                        new_value[data_index] = toNumber(display_value);

                        setPaatValues(new_value);
                    }}
                    onFocus={(event) => {
                        event.target.select();
                    }}
                    onKeyPress={(e) => {
                        if (e.key === "Enter") {
                            e.target.blur();
                        }
                    }}
                />
            </span>
        );
    }

    let attachmentOptions = [];
    const gableOrPitched =
        areaData?.SHAPE?.DesignType === DESIGN_TYPES.GABLE_PORTAL ||
        areaData?.SHAPE?.DesignType === DESIGN_TYPES.PITCHED;
    const is_flat = areaData?.SHAPE?.DesignType === DESIGN_TYPES.FLAT;
    const isSideAttachment = roofAlignment.includes("Side");
    let isWaterShed = undefined;
    if (item?.is_watershed !== undefined) {
        isWaterShed = item?.is_watershed;
    } else if (areaData?.META) {
        if (roofAlignment === "Front" && areaData?.META?.FrontState) {
            isWaterShed = areaData?.META?.FrontState.IsWaterShed;
        } else if (roofAlignment === "Back" && areaData?.META?.BackState) {
            isWaterShed = areaData?.META?.BackState.IsWaterShed;
        } else if (roofAlignment === "Side") {
            if (ref.includes("Left") && areaData?.META?.LeftState) {
                isWaterShed = areaData?.META?.LeftState.IsWaterShed;
            } else if (ref.includes("Right") && areaData?.META?.RightState) {
                isWaterShed = areaData?.META?.RightState.IsWaterShed;
            } else {
                isWaterShed = areaData?.META?.RightState.IsWaterShed || areaData?.META?.LeftState.IsWaterShed;
            }
        }
    }

    let new_default_attachment_type = "";

    for (let attachmentType in ATTACHMENT_TYPES) {
        const attachmentData = ATTACHMENT_TYPES[attachmentType];
        const allowForFlat = attachmentData?.allow_for_flat === false ? false : true;
        const allowForGable = attachmentData?.allow_for_gable === true ? true : false;
        const allowOnSide = attachmentData?.allow_on_side === true ? true : false;
        const allowForGableSide = attachmentData?.allow_for_gable_side === false ? false : true;
        const allowForWaterShed = attachmentData?.allow_for_watershed_side === false ? false : true;
        const displayName = attachmentData?.display_name || attachmentType;

        const deckOnly = attachmentData?.deck_only;

        if (is_deck_mode && !deckOnly) continue;

        let isDisabled = true;
        let disabledTooltip = "";

        const textInsert = !window.LYSAGHT ? " or pitched roof " : " ";

        if (gableOrPitched && isSideAttachment && !allowForGableSide) {
            disabledTooltip = `Not available for side attachments on gable${textInsert}designs`;
        } else if (!allowForWaterShed && isWaterShed === true) {
            disabledTooltip = "Not available on watershed (drainage) side";
        } else if (
            gableOrPitched &&
            ((!isSideAttachment && !allowForGable) || (isSideAttachment && !allowForGableSide))
        ) {
            disabledTooltip = `Not available on gable${textInsert}designs`;
        } else if (!allowOnSide && isSideAttachment) {
            disabledTooltip = "Not available for side attachments";
        } else if (is_flat && !allowForFlat) {
            disabledTooltip = `Not available on skillion designs`;
        } else {
            isDisabled = false;
        }

        attachmentOptions.push({
            Key: attachmentType,
            Display: displayName,
            disabled: isDisabled,
            disabledTooltip: disabledTooltip,
        });

        if (isDisabled && attachmentTypeValue === attachmentType) {
            attachmentTypeValue = "";
        }
        if (new_default_attachment_type == "" && !isDisabled) {
            new_default_attachment_type = attachmentType;
        }
    }

    if (new_default_attachment_type !== "" && attachmentTypeValue === "") {
        attachmentTypeValue = new_default_attachment_type;
        setAttachmentType(new_default_attachment_type);
    }

    let variations = [];
    if (attachmentDefinition?.variations) {
        for (let variation in attachmentDefinition?.variations) {
            let isDisabled = false;
            let disabledTooltip = "";

            variations.push({
                Key: variation,
                Display: variation,
                disabled: isDisabled,
                disabledTooltip: disabledTooltip,
            });
        }
    }

    const InitialiseCanvas = (id) => {
        window.attach_paper_initialising = true;
        // return;
        // Get a reference to the canvas object
        var attach_canvas = window.document.getElementById(id);
        if (!attach_canvas) {
            return false;
        }

        // Create an empty project and a view for the canvas:
        var attach_paper = new paper.PaperScope();
        attach_paper.setup(attach_canvas);
        attach_paper.project.options.handleSize = 6;
        attach_paper.settings.hitTolerance = 6;
        attach_paper.view.zoom = 1;
        attach_paper.view.scale = 25;
        attach_paper.view.scale = 25;
        attach_paper.view.viewSize = new attach_paper.Size(800, 600);

        window.attach_paper2 = attach_paper;
        window.attach_paper2_canvas = attach_canvas;

        attach_paper.view.onMouseDown = (e) => {
            window.attach_dragging = false;
            _this.downPoint = e.point;
            _this.downPointScreen = new attach_paper.Point(e.event.x, e.event.y);
            _this.downButton = e.event.button;
        };

        attach_paper.view.onMouseUp = (e) => {
            window.attach_dragging = false;
        };

        attach_paper.view.onMouseMove = (e) => {};

        attach_paper.view.onMouseDrag = function (e) {
            var distance_dragged = _this.downPoint ? _this.downPoint.getDistance(e.point) : 0;
            var distance_screen_dragged = _this.downPointScreen.getDistance(
                new attach_paper.Point(e.event.x, e.event.y)
            );

            attach_paper.view.element.style.setProperty("cursor", "all-scroll");
            // var offset = _this.downPoint.subtract(e.point);

            //
            if (distance_screen_dragged > 20 && !window.attach_dragging) {
                window.attach_dragging = true;
            } else if (
                (_this.downButton === 0 || _this.downButton === 1 || _this.downButton === 2) &&
                window.attach_dragging
            ) {
                _this.dragging = true;
                var offset = _this.downPoint.subtract(e.point);
                attach_paper.view.center = attach_paper.view.center.add(offset);
                // offset_grid(offset);
            }
        };

        if (attach_canvas)
            attach_canvas.addEventListener(
                "wheel",
                function (e) {
                    var delta = e.deltaY;
                    var zoom = attach_paper.view.zoom * (1 - delta / 3000);

                    // zoom = zoom * (1 + delta / 5500);
                    //
                    if (zoom > 7) zoom = 7;
                    if (zoom < 0.03) zoom = 0.03;
                    attach_paper.view.zoom = zoom;

                    // offset_grid();

                    // e.preventDefault();
                    // e.stopPropagation();
                    e.preventDefault();
                    e.stopPropagation();
                },
                { passive: true }
            );
        if (attach_canvas)
            attach_canvas.addEventListener("contextmenu", function (e) {
                e.preventDefault();
            });

        attach_paper.activate();
        return true;
    };

    function zoomAll(sidebar_adjustment_factor = 0) {
        window.attach_paper2.activate();
        let paper = window.attach_paper2;
        if (paper.project.activeLayer.children.length === 0) return;

        let topbar_adjustment_factor = 0;
        var screen_size = {
            width: paper.view.viewSize.width - sidebar_adjustment_factor,
            height: paper.view.viewSize.height,
        };
        var screen_ratio = screen_size.width / screen_size.height;

        var objects_size = paper.project.activeLayer.bounds.size;
        var objects_ratio = objects_size.width / objects_size.height;

        if (isNaN(objects_ratio)) return;
        var zoom = 1;
        if (objects_ratio > screen_ratio) {
            //scale by width
            zoom = screen_size.width / objects_size.width;
        } else {
            //scale by height
            zoom = screen_size.height / objects_size.height;
        }
        paper.view.zoom = zoom * 0.85;
        //
        let center = paper.project.activeLayer.bounds.center;
        let adjusment = new paper.Point(
            sidebar_adjustment_factor / paper.view.zoom / 2,
            -topbar_adjustment_factor / paper.view.zoom / 2
        );

        // // // fix all text
        let change = 0.15 / paper.view.zoom;

        paper.project.activeLayer.children.forEach(function (item) {
            if (item.fontSize) {
                paper.project.activeLayer.addChild(item);
            }
        });
        paper.project.activeLayer.children.forEach(function (item) {
            if (item.fontSize) {
                // , toNumber(item.fontSize) * change);
                item.fontSize = toNumber(item.fontSize) * change;
            }
        });

        paper.view.center = center.add(adjusment);
    }

    const makeMarks = (min, max, spacing = 50) => {
        let marks = [];

        if (Math.abs(max - min) / spacing > 20) spacing = spacing * 4;
        else if (Math.abs(max - min) / spacing > 10) spacing = spacing * 2;

        // if (Number(max) - Number(min) > 1000) {
        //     spacing = 100;
        // }
        // if (Number(max) - Number(min) > 1500) {
        //     spacing = 200;
        // }

        for (let i = Number(min); i < Number(max) + 1; i += spacing) {
            marks.push({
                value: Math.round(i * 10) / 10,
                label: Math.round(i * 10) / 10,
            });
        }
        return marks;
    };

    let allow_h_offset =
        attachmentDefinition?.depth_offset_editable !== undefined ? attachmentDefinition?.depth_offset_editable : true;

    let allow_v_offset =
        attachmentDefinition?.height_offset_editable !== undefined
            ? attachmentDefinition?.height_offset_editable
            : true;

    if (roofAlignment.includes("Side") && attachmentDefinition?.height_offset_editable_side !== undefined) {
        allow_v_offset = attachmentDefinition.height_offset_editable_side;
    }

    if (ref === "CBM" && attachmentDefinition?.height_offset_editable_side !== undefined) {
        // allow_v_offset = attachmentDefinition.height_offset_editable_side;
    }

    let wall_only = attachmentDefinition?.wall_only !== undefined ? attachmentDefinition?.wall_only : false;

    let allow_eave_width = true;
    if (wall_only) {
        allow_h_offset = false;
        if (!attachmentTypeVariation.includes("Riser")) allow_v_offset = false;
        allow_eave_width = false;
    }

    let min_flyover =
        (eaveValue + (wallType === "Timber Frame" ? 90 : 40 + 110 + 90)) * Tan(house_pitch) +
        beam_height +
        175 / Cos(house_pitch);

    //

    let min_riser_height = Math.round(120 / Cos(house_pitch) + 90 + 25 + (window.LYSAGHT ? beam_height : beam_height));
    let max_riser_height = window.LYSAGHT ? 500 + beam_height : 1000;

    let min_vertical_offset =
        attachmentDefinition?.height_offset_min !== undefined
            ? attachmentDefinition?.height_offset_min === "Beam_Height"
                ? beam_height
                : attachmentDefinition?.height_offset_min === "-Sheet_Height"
                ? -roof_sheet_height
                : attachmentDefinition?.height_offset_min === "Flyover"
                ? min_flyover
                : attachmentDefinition?.height_offset_min
            : -1000;

    let max_vertical_offset =
        attachmentDefinition?.height_offset_max !== undefined
            ? attachmentDefinition?.height_offset_min === "Flyover"
                ? min_flyover + (max_riser_height - min_riser_height)
                : attachmentDefinition?.height_offset_max
            : 1000;

    if (attachmentTypeVariation.includes("Riser")) {
        max_vertical_offset = window.LYSAGHT ? 450 : 500;
        if (roofAlignment.includes("Side")) {
            min_vertical_offset = beam_height;
            min_riser_height = beam_height;
        }
    }
    if (attachmentTypeValue.includes("Rafter Brackets")) {
    }
    if (!attachmentTypeValue.includes("Flyover")) {
        if (vOffset < min_vertical_offset) setVOffset(min_vertical_offset);
        if (vOffset > max_vertical_offset) setVOffset(max_vertical_offset);
    }

    let slider_margin = "20px";
    if (max < attachment_length || min > 0) slider_margin = "-12px";

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle style={{ cursor: "move" }}>
                Modify Attachment Options {window.debug ? "ref " + ref : ""}
            </DialogTitle>
            <DialogContent style={{ overflow: "hidden", display: "flex", flexDirection: "column", height: "100%" }}>
                <BSL_Common.SectionRow
                    style={{
                        height: "100%",
                        paddingLeft: "10px",
                        overflowY: "auto",
                        overflowX: "hidden",
                        scrollbarGutter: "stable",
                    }}
                >
                    <BSL_Common.SectionColumn
                        style={{
                            flex: 4,
                            minWidth: 350,
                        }}
                    >
                        {!item && <DialogContentText>Attachment data is not defined</DialogContentText>}
                        {item && (
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <BSL_TextInput
                                    label="Label for this attachment"
                                    tight
                                    placeholder="eg; House / Shed / Existing Structure"
                                    value={attachmentLabel}
                                    onBlur={(val) => {
                                        setAttachmentLabel(val);
                                    }}
                                    style={{
                                        paddingTop: "0px",
                                    }}
                                />
                                <BSL_Select
                                    value={attachmentTypeValue}
                                    tight={true}
                                    items={attachmentOptions}
                                    onChange={handleAttachmentType}
                                    inputWidth="95%"
                                />
                                {variations && (
                                    <SegmentedButtonGroup
                                        value={attachmentTypeVariation}
                                        allowWrap
                                        tight
                                        items={variations}
                                        onChange={(e, v) => setAttachmentTypeVariation(v)}
                                        style={{ flex: "none" }}
                                    />
                                )}
                                {!is_deck_mode && (
                                    <>
                                        <BSL_Slider
                                            label={
                                                "Area Pitching Height " +
                                                (areaData?.SHAPE?.DesignType === DESIGN_TYPES.GABLE_PORTAL
                                                    ? "(Underside of Edge Beam)"
                                                    : "(Underside of Sheet)")
                                            }
                                            helperText={
                                                "From FFL to Underside of " +
                                                (areaData?.SHAPE?.DesignType === DESIGN_TYPES.GABLE_PORTAL
                                                    ? "Edge Beam"
                                                    : "Roof Sheet") +
                                                ". Affects all attachments in area"
                                            }
                                            tight
                                            value={area_height}
                                            min={2000}
                                            max={5000}
                                            suffix={"mm"}
                                            marks={makeMarks(2000, 5000, 500)}
                                            step={10}
                                            onChange={(e, val) => {
                                                setAreaHeight(val);
                                            }}
                                            onChangeStep={(e, val) => {
                                                setAreaHeight(val);
                                            }}
                                            editableTextField={true}
                                        />

                                        {allow_v_offset && !attachmentTypeValue.includes("Flyover") && (
                                            <BSL_Slider
                                                label={
                                                    attachmentDefinition?.height_offset_label
                                                        ? attachmentDefinition?.height_offset_label
                                                        : "Attachment Spacing Below Pitching Height"
                                                }
                                                tight
                                                suffix={"mm"}
                                                value={vOffset}
                                                min={min_vertical_offset}
                                                max={max_vertical_offset}
                                                marks={makeMarks(min_vertical_offset, max_vertical_offset)}
                                                step={10}
                                                onChange={(e, val) => {
                                                    setVOffset(val);
                                                }}
                                                onChangeStep={(e, val) => {
                                                    setVOffset(val);
                                                }}
                                                editableTextField={true}
                                            />
                                        )}

                                        {attachmentTypeValue.includes("Flyover") && (
                                            <BSL_Slider
                                                label={"Flyover Riser Height Above Top Plate"}
                                                tight
                                                suffix={"mm"}
                                                value={riserHeight}
                                                min={min_riser_height}
                                                max={max_riser_height}
                                                marks={makeMarks(
                                                    Math.round(min_riser_height / 100) * 100,
                                                    max_riser_height
                                                )}
                                                step={10}
                                                onChange={(e, val) => {
                                                    setRiserHeight(val);
                                                }}
                                                onChangeStep={(e, val) => {
                                                    setRiserHeight(val);
                                                }}
                                                editableTextField={true}
                                            />
                                        )}

                                        {allow_eave_width && (
                                            <BSL_Slider
                                                label={"Eave Width"}
                                                tight
                                                value={eaveValue}
                                                min={0}
                                                max={900}
                                                suffix={"mm"}
                                                marks={makeMarks(0, 900, 100)}
                                                step={10}
                                                onChange={(e, val) => {
                                                    let new_val = val;
                                                    if (Math.abs(new_val - 450) < 10) new_val = 450;
                                                    if (Math.abs(new_val - 600) < 10) new_val = 600;
                                                    setEaveValue(new_val);
                                                }}
                                                onChangeStep={(e, val) => {
                                                    let new_val = val;
                                                    if (Math.abs(new_val - 450) < 10) new_val = 450;
                                                    if (Math.abs(new_val - 600) < 10) new_val = 600;
                                                    setEaveValue(new_val);
                                                }}
                                                editableTextField={true}
                                            />
                                        )}
                                        {allow_h_offset && (
                                            <BSL_Slider
                                                label={
                                                    attachmentDefinition?.depth_offset_label
                                                        ? attachmentDefinition?.depth_offset_label
                                                        : "Horizontal Offset from Fascia"
                                                }
                                                disabled={
                                                    attachmentDefinition?.depth_offset_editable !== undefined
                                                        ? !attachmentDefinition?.depth_offset_editable
                                                        : false
                                                }
                                                tight
                                                value={hOffset}
                                                min={
                                                    attachmentDefinition?.depth_offset_min !== undefined
                                                        ? attachmentDefinition?.depth_offset_min
                                                        : 0
                                                }
                                                max={
                                                    attachmentDefinition?.depth_offset_max !== undefined
                                                        ? attachmentDefinition?.depth_offset_max
                                                        : 500
                                                }
                                                marks={makeMarks(
                                                    attachmentDefinition?.depth_offset_min !== undefined
                                                        ? attachmentDefinition?.depth_offset_min
                                                        : 0,
                                                    attachmentDefinition?.depth_offset_max !== undefined
                                                        ? attachmentDefinition?.depth_offset_max
                                                        : 500
                                                )}
                                                suffix={"mm"}
                                                step={10}
                                                onChange={(e, val) => {
                                                    setHOffset(val);
                                                }}
                                                onChangeStep={(e, val) => {
                                                    setHOffset(val);
                                                }}
                                                editableTextField={true}
                                            />
                                        )}
                                    </>
                                )}

                                <BSL_ControlContainer
                                    label={"Set Partial Attachment"}
                                    style={{ paddingRight: "20px", paddingBottom: "0px" }}
                                    helperText={min_attachment_length > 0 ? min_attachment_length_helpertext : ""}
                                >
                                    {(max < attachment_length || min > 0) && (
                                        <div
                                            style={{
                                                width: "100%",
                                                paddingTop: "10px",
                                                display: "flex",
                                            }}
                                        >
                                            {min > 0 && (
                                                <div
                                                    style={{
                                                        width: "calc(" + (min / attachment_length) * 100 + "%)",
                                                        background:
                                                            "repeating-linear-gradient(45deg,#B1B1B1,#B1B1B1 2px,#F0F0F0 2px,#F0F0F0 10px)",
                                                        height: "18px",
                                                    }}
                                                ></div>
                                            )}
                                            <div
                                                style={{
                                                    width: "calc(" + (min / attachment_length) * 100 + "%)",
                                                    flex: 1,
                                                }}
                                            ></div>

                                            {max < attachment_length && (
                                                <div
                                                    style={{
                                                        width:
                                                            "calc(" +
                                                            ((attachment_length - max) / attachment_length) * 100 +
                                                            "%)",
                                                        background:
                                                            "repeating-linear-gradient(45deg,#B1B1B1,#B1B1B1 2px,#F0F0F0 2px,#F0F0F0 10px)",
                                                        height: "18px",
                                                    }}
                                                ></div>
                                            )}
                                        </div>
                                    )}
                                    <AttachmentSlider
                                        ThumbComponent={AirbnbThumbComponent}
                                        value={paatValues}
                                        onChange={handlePaatValuesChange}
                                        valueLabelDisplay="auto"
                                        aria-labelledby="range-slider"
                                        getAriaValueText={valuetext}
                                        // valueLabelDisplay="on"
                                        min={0}
                                        step={10}
                                        max={attachment_length}
                                        // slider_margin={slider_margin}
                                        style={{
                                            marginTop: slider_margin,
                                        }}
                                    />
                                    <div
                                        style={{
                                            width: "100%",
                                            marginTop: "-8px",
                                        }}
                                    >
                                        <span
                                            style={{
                                                marginLeft:
                                                    ((paatValues[1] + paatValues[0]) / 2 / attachment_length) * 100 -
                                                    6 +
                                                    "%",
                                            }}
                                        >
                                            <input
                                                type="text"
                                                id="standard-basic"
                                                label=""
                                                value={attsch_length_display}
                                                className={classes.attachLengthText}
                                                onChange={(e) => setAttachDisplay(e.target.value)}
                                                onBlur={() => {
                                                    let new_value = [...paatValues];
                                                    let new_end_pos = new_value[0] + toNumber(attsch_length_display);
                                                    let start_end_adj = 0;
                                                    if (new_end_pos > max) {
                                                        start_end_adj = new_end_pos - max;
                                                        new_end_pos = max;
                                                    }

                                                    new_value[0] = new_value[0] - toNumber(start_end_adj);
                                                    new_value[1] = toNumber(new_end_pos);
                                                    //
                                                    setPaatValues(new_value);
                                                    setAttachDisplay(null);
                                                }}
                                                onFocus={(event) => {
                                                    event.target.select();
                                                }}
                                                onKeyPress={(e) => {
                                                    if (e.key === "Enter") {
                                                        e.target.blur();
                                                    }
                                                }}
                                            />
                                        </span>
                                    </div>
                                </BSL_ControlContainer>
                                {!is_deck_mode && (
                                    <>
                                        {attachmentDefinition?.rSBLC_option && (
                                            <BSL_CheckBox
                                                tight
                                                checked={rSBLC}
                                                label={
                                                    <span style={{ fontSize: "13px", fontWeight: "200" }}>
                                                        Reinforced Rafter Brackets (RSBLC)
                                                    </span>
                                                }
                                                returnInt
                                                onChange={(val) => setRSBLC(val)}
                                                style={{
                                                    padding: "0px 0px 4px 0px",
                                                }}
                                            />
                                        )}
                                        <BSL_CheckBox
                                            tight
                                            checked={extendAttachmentToSheetEnd}
                                            label={
                                                <span style={{ fontSize: "13px", fontWeight: "200" }}>
                                                    Extend Attachment To End of Sheet (such as for overhangs)
                                                </span>
                                            }
                                            returnInt
                                            onChange={(val) => setExtendAttachmentToSheetEnd(val)}
                                            style={{
                                                padding: "0px 0px 4px 0px",
                                            }}
                                        />
                                        <BSL_CheckBox
                                            tight
                                            checked={partialAttachmentFasciaBeamFlush}
                                            label={
                                                <span style={{ fontSize: "13px", fontWeight: "200" }}>
                                                    Run Partial Attachment Beam flush with attachment
                                                </span>
                                            }
                                            returnInt
                                            onChange={(val) => setPartialAttachmentFasciaBeamFlush(val)}
                                            style={{
                                                padding: "0px 0px 4px 0px",
                                            }}
                                        />
                                        <BSL_CheckBox
                                            tight
                                            checked={fasciaIsRaked}
                                            label={
                                                <span style={{ fontSize: "13px", fontWeight: "200" }}>
                                                    Attachment is Raked to Match Roof Pitch (does not show on this
                                                    preview)
                                                </span>
                                            }
                                            returnInt
                                            onChange={(val) => setFasciaIsRaked(val)}
                                            style={{
                                                padding: "0px 0px 4px 0px",
                                            }}
                                        />
                                        {attachmentDefinition?.has_beam && (
                                            <BSL_Common.SectionRow>
                                                <BSL_TextInput
                                                    label={"Left Bracket Cantilever"}
                                                    style={{ maxWidth: "120px", color: "white" }}
                                                    value={leftCantilever}
                                                    tight={true}
                                                    onEnter={(e) => setLeftCantilever(e.target.value)}
                                                    onChange={(value) => {
                                                        setLeftCantilever(value);
                                                    }}
                                                />
                                                <BSL_TextInput
                                                    label={"Right Bracket Cantilever"}
                                                    style={{ maxWidth: "120px", color: "white" }}
                                                    value={rightCantilever}
                                                    tight={true}
                                                    onEnter={(e) => setRightCantilever(e.target.value)}
                                                    onChange={(value) => {
                                                        setRightCantilever(value);
                                                    }}
                                                />
                                            </BSL_Common.SectionRow>
                                        )}
                                        {(num_brackets > 0 ||
                                            attachmentTypeValue.includes("Flyover") ||
                                            (!data_mods && default_FasciaType.includes("Flyover"))) && (
                                            <BSL_Select
                                                label={
                                                    "Custom Number of " +
                                                    (attachmentTypeValue.includes("Flyover") ||
                                                    (!data_mods && default_FasciaType.includes("Flyover"))
                                                        ? window.LYSAGHT
                                                            ? "Jumbo "
                                                            : "BK50 "
                                                        : "") +
                                                    "Brackets"
                                                }
                                                style={{
                                                    paddingRight: "20px",
                                                }}
                                                value={numBrackets}
                                                tight={true}
                                                items={rafterBracketMenuItems}
                                                onChange={(e) => {
                                                    setnumBrackets(e.target.value);
                                                }}
                                                helperText={
                                                    <>
                                                        Number of Brackets (min: {min_rafters}; recommended number
                                                        (auto)=
                                                        {recommended_brackets})
                                                        {numBrackets > 0 && numBrackets < recommended_brackets && (
                                                            <>
                                                                <br />
                                                                <WarningIcon
                                                                    style={{
                                                                        color: "red",
                                                                        height: "16px",
                                                                        verticalAlign: "sub",
                                                                    }}
                                                                />{" "}
                                                                Warning: less brackets than recommended
                                                            </>
                                                        )}
                                                    </>
                                                }
                                            />
                                        )}

                                        {(!item || devMode) && (
                                            <div style={{ background: "#bbbbbb" }}>
                                                <BSL_Slider
                                                    label={"Structure Roof Pitch"}
                                                    tight
                                                    value={roof_pitch}
                                                    min={-30}
                                                    max={30}
                                                    suffix={"°"}
                                                    marks={makeMarks(-30, 30, 5)}
                                                    step={1}
                                                    onChange={(e, val) => {
                                                        setRoof_pitch(val);
                                                    }}
                                                    onChangeStep={(e, val) => {
                                                        setRoof_pitch(val);
                                                    }}
                                                    editableTextField={true}
                                                />
                                                <BSL_Slider
                                                    label={"House Roof Pitch"}
                                                    tight
                                                    value={house_pitch}
                                                    min={2}
                                                    max={40}
                                                    suffix={"°"}
                                                    marks={makeMarks(5, 40, 2.5)}
                                                    step={0.5}
                                                    onChange={(e, val) => {
                                                        if (val === 22 || val == 23) setHousePitch(22.5);
                                                        else setHousePitch(val);
                                                    }}
                                                    onChangeStep={(e, val) => {
                                                        if (val === 22 || val == 23) setHousePitch(22.5);
                                                        else setHousePitch(val);
                                                    }}
                                                    editableTextField={true}
                                                />
                                                <BSL_Slider
                                                    label={"Attachment Length"}
                                                    tight
                                                    value={attachment_length}
                                                    min={100}
                                                    max={20000}
                                                    suffix={"mm"}
                                                    marks={makeMarks(0, 20000, 1000)}
                                                    step={1}
                                                    onChange={(e, val) => {
                                                        let paat_p1 = toNumber(paatValues[0]);
                                                        let paat_p2 = toNumber(paatValues[1]);

                                                        let paat_val = [...paatValues];
                                                        if (
                                                            Math.abs(paat_p2 - attachment_length) < 50 ||
                                                            paat_p2 > val - 50
                                                        ) {
                                                            paat_val[1] = val;
                                                        }
                                                        if (paat_p1 > val - 300) {
                                                            paat_val[0] = val - 300;
                                                        }
                                                        setPaatValues(paat_val);
                                                        setAttachmentLength(val);
                                                    }}
                                                    onChangeStep={(e, val) => {
                                                        let paat_p1 = toNumber(paatValues[0]);
                                                        let paat_p2 = toNumber(paatValues[1]);

                                                        let paat_val = [...paatValues];
                                                        if (
                                                            Math.abs(paat_p2 - attachment_length) < 10 ||
                                                            paat_p2 > val
                                                        ) {
                                                            paat_val[1] = val;
                                                        }
                                                        if (paat_p1 > val - 300) {
                                                            paat_val[0] = val - 300;
                                                        }
                                                        setPaatValues(paat_val);

                                                        setAttachmentLength(val);
                                                    }}
                                                    editableTextField={true}
                                                />
                                                <SegmentedButtonGroup
                                                    label={"Brand"}
                                                    value={brand}
                                                    items={["Lysaght", "Fielders"]}
                                                    onChange={(e, v) => {
                                                        setBrand(v);
                                                    }}
                                                    style={{ flex: "none" }}
                                                />
                                                <SegmentedButtonGroup
                                                    label={"Alignment"}
                                                    value={roofAlignment}
                                                    items={["Side", "Back", "RightSide", "Front"]}
                                                    onChange={(e, v) => {
                                                        setRoofAlignment(v);
                                                    }}
                                                    style={{ flex: "none" }}
                                                />
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        )}
                    </BSL_Common.SectionColumn>
                    {!is_deck_mode && (
                        <BSL_Common.SectionColumn>
                            <div
                                style={{
                                    width: "100%",
                                    height: "600px",
                                    background: "rgb(148,148,148)",
                                    background:
                                        "linear-gradient(339deg, rgba(148,148,148,1) 0%, rgba(227,227,227,1) 76%)",
                                    borderRadius: "10px",
                                }}
                                onScroll={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    e.nativeEvent.stopImmediatePropagation();
                                }}
                            >
                                <canvas
                                    id="attachmentCanvas"
                                    width="800"
                                    height="600"
                                    style={
                                        {
                                            // border: "1px solid #000000",
                                        }
                                    }
                                    onScroll={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        e.nativeEvent.stopImmediatePropagation();
                                    }}
                                ></canvas>
                                <div
                                    style={{
                                        position: "absolute",
                                        zIndex: 100,
                                        top: 50,
                                        right: 25,
                                        fontSize: "small",
                                        marginLeft: "20px",
                                    }}
                                >
                                    *bracket number, location and diagram is indicative only. Check 3d model for a more
                                    accurate representation.
                                </div>
                            </div>
                        </BSL_Common.SectionColumn>
                    )}
                </BSL_Common.SectionRow>
            </DialogContent>
            <DialogActions>
                <div
                    style={{
                        position: "absolute",
                        left: "20px",
                    }}
                >
                    <Button autoFocus onClick={handleDelete} color="primary">
                        Reset to Defaults
                    </Button>
                    <Button autoFocus onClick={handleUnattach} color="primary" disabled={!attach_tag}>
                        Unattach
                    </Button>
                    {window.debug && (
                        <Button autoFocus onClick={() => setDevMode(!devMode)} color="primary">
                            Dev Mode
                        </Button>
                    )}
                </div>
                <Button autoFocus onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={saveAttachmentModifications} color="primary">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export function getRoofAlignmentAndPitch(areaData, ref) {
    let roofPitch = areaData?.SHAPE?.RoofPitch ? areaData?.SHAPE?.RoofPitch : 5;

    let roof_alignment_default = "Back";
    if (ref.includes("Right")) roof_alignment_default = "RightSide";
    else if (ref.includes("Left")) roof_alignment_default = "Side";
    else if (ref.includes("Front")) roof_alignment_default = "Front";

    //

    if (ref.startsWith("C")) {
        // cutout....
        let cutout_side = "BackRight";
        if (ref.startsWith("CBR")) cutout_side = "BackRight";
        if (ref.startsWith("CBL")) cutout_side = "BackLeft";
        if (ref.startsWith("CFL")) cutout_side = "FontLeft";
        if (ref.startsWith("CFR")) cutout_side = "FontRight";
        let cutout_type = areaData.SHAPE.CUTOUTS?.[cutout_side + "-CutoutType"];

        if (cutout_type === "Angle") {
            //adjust pitch
            let cutout_angle_r = Math.atan(
                areaData.SHAPE.CUTOUTS?.[cutout_side + "-WidthY"] / areaData.SHAPE.CUTOUTS?.[cutout_side + "-WidthX"]
            );
            if (Math.abs(cutout_angle_r) < 0.2) {
                roof_alignment_default = "Back";
            } else {
                if (cutout_side.includes("Right")) roof_alignment_default = "RightSide";
                if (cutout_side.includes("Left")) roof_alignment_default = "Side";
                roofPitch = roofPitch * Math.sin(cutout_angle_r);
            }
        } else {
            if (ref.includes(" Y")) {
                if (cutout_side.includes("Right")) roof_alignment_default = "RightSide";
                else roof_alignment_default = "Side";
            } else {
                roof_alignment_default = "Back";
            }
        }
    }

    if (areaData?.SHAPE?.DesignType === DESIGN_TYPES.FLAT) {
        if (areaData?.SHAPE?.SheetDirection == "Left") {
            if (roof_alignment_default === "Back") roof_alignment_default = "Side";
            else if (roof_alignment_default === "Side") roof_alignment_default = "Front";
            else if (roof_alignment_default === "Front") roof_alignment_default = "RightSide";
            else if (roof_alignment_default === "RightSide") roof_alignment_default = "Back";
        }
        if (areaData?.SHAPE?.SheetDirection == "Right") {
            if (roof_alignment_default === "Back") roof_alignment_default = "RightSide";
            else if (roof_alignment_default === "RightSide") roof_alignment_default = "Front";
            else if (roof_alignment_default === "Front") roof_alignment_default = "Side";
            else if (roof_alignment_default === "Side") roof_alignment_default = "Back";
        }
    }

    if (areaData?.SHAPE?.DesignType === DESIGN_TYPES.GABLE_PORTAL) {
        roofPitch = -roofPitch;
        if (roof_alignment_default.includes("Side")) roofPitch = 0;
    }
    if (areaData?.SHAPE?.DesignType === DESIGN_TYPES.PITCHED) {
        if (roof_alignment_default.includes("Side")) roof_alignment_default = "Back";
        else roof_alignment_default = "Side";

        roofPitch = -roofPitch;
        if (roof_alignment_default.includes("Side")) roofPitch = 0;
    }

    return { alignment: roof_alignment_default, pitch: roofPitch };
}

SpecModifyAttachmentDialog2.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};
